// // // // // import React, { useState } from "react";
// // // // // import axios from "axios";
// // // // // import Swal from "sweetalert2";
// // // // // import { useTheme } from "../context/ThemeContext";

// // // // // const RegistrationModal = ({ isOpen, onClose }) => {
// // // // //   const { colors } = useTheme();
// // // // //   const [formData, setFormData] = useState({
// // // // //     branch: "",
// // // // //     studentName: "",
// // // // //     schoolName: "",
// // // // //     villageOrCity: "",
// // // // //     address: "",
// // // // //     mobileNumber: "",
// // // // //   });
// // // // //   const [branchChoice, setBranchChoice] = useState(""); // 'Commerce' | 'Science' | 'Other'
// // // // //   const [branchOther, setBranchOther] = useState("");
// // // // //   const [isSubmitting, setIsSubmitting] = useState(false);

// // // // //   const handleChange = (e) => {
// // // // //     setFormData({
// // // // //       ...formData,
// // // // //       [e.target.name]: e.target.value,
// // // // //     });
// // // // //   };

// // // // //   const handleSubmit = async (e) => {
// // // // //     e.preventDefault();
// // // // //     setIsSubmitting(true);

// // // // //     try {
// // // // //       // Resolve final branch value based on selection
// // // // //       const finalBranch =
// // // // //         branchChoice === "Other" ? (branchOther || "").trim() : branchChoice;
// // // // //       const payload = { ...formData, branch: finalBranch };
// // // // //       const response = await axios.post(
// // // // //         "https://gurukulschools.org/api/api/public/student-registration",
// // // // //         payload
// // // // //       );

// // // // //       if (response.status === 200) {
// // // // //         Swal.fire({
// // // // //           icon: "success",
// // // // //           title: "Registration Successful!",
// // // // //           text: "Your registration has been submitted successfully. We will contact you soon.",
// // // // //           confirmButtonColor: "#0ea5e9",
// // // // //           confirmButtonText: "OK",
// // // // //         });

// // // // //         // Reset form
// // // // //         setFormData({
// // // // //           branch: "",
// // // // //           studentName: "",
// // // // //           schoolName: "",
// // // // //           villageOrCity: "",
// // // // //           address: "",
// // // // //           mobileNumber: "",
// // // // //         });
// // // // //         setBranchChoice("");
// // // // //         setBranchOther("");

// // // // //         onClose();
// // // // //       }
// // // // //     } catch (error) {
// // // // //       Swal.fire({
// // // // //         icon: "error",
// // // // //         title: "Registration Failed",
// // // // //         text:
// // // // //           error.response?.data?.message ||
// // // // //           "Something went wrong. Please try again.",
// // // // //         confirmButtonColor: "#ef4444",
// // // // //         confirmButtonText: "OK",
// // // // //       });
// // // // //     } finally {
// // // // //       setIsSubmitting(false);
// // // // //     }
// // // // //   };

// // // // //   if (!isOpen) return null;

// // // // //   const modalOverlayStyle = {
// // // // //     position: "fixed",
// // // // //     top: 0,
// // // // //     left: 0,
// // // // //     right: 0,
// // // // //     bottom: 0,
// // // // //     backgroundColor: "rgba(0, 0, 0, 0.6)",
// // // // //     display: "flex",
// // // // //     alignItems: "center",
// // // // //     justifyContent: "center",
// // // // //     zIndex: 2000,
// // // // //     padding: "1rem",
// // // // //     animation: "fadeIn 0.3s ease-in-out",
// // // // //   };

// // // // //   const modalContentStyle = {
// // // // //     background: colors.card,
// // // // //     borderRadius: "1rem",
// // // // //     padding: "2rem",
// // // // //     maxWidth: "500px",
// // // // //     width: "100%",
// // // // //     maxHeight: "90vh",
// // // // //     overflowY: "auto",
// // // // //     boxShadow: colors.cardShadow,
// // // // //     position: "relative",
// // // // //     animation: "slideUp 0.3s ease-in-out",
// // // // //   };

// // // // //   const closeButtonStyle = {
// // // // //     position: "absolute",
// // // // //     top: "1rem",
// // // // //     right: "1rem",
// // // // //     background: "none",
// // // // //     border: "none",
// // // // //     fontSize: "1.5rem",
// // // // //     cursor: "pointer",
// // // // //     color: colors.textSecondary,
// // // // //     width: "32px",
// // // // //     height: "32px",
// // // // //     display: "flex",
// // // // //     alignItems: "center",
// // // // //     justifyContent: "center",
// // // // //     borderRadius: "50%",
// // // // //     transition: "all 0.2s ease",
// // // // //   };

// // // // //   const formGroupStyle = {
// // // // //     marginBottom: "1.5rem",
// // // // //   };

// // // // //   const labelStyle = {
// // // // //     display: "block",
// // // // //     marginBottom: "0.5rem",
// // // // //     color: colors.text,
// // // // //     fontWeight: "600",
// // // // //     fontSize: "0.95rem",
// // // // //   };

// // // // //   const inputStyle = {
// // // // //     width: "100%",
// // // // //     padding: "0.75rem",
// // // // //     border: `1px solid ${colors.border}`,
// // // // //     borderRadius: "0.5rem",
// // // // //     fontSize: "1rem",
// // // // //     fontFamily: "inherit",
// // // // //     transition: "border-color 0.2s ease",
// // // // //     boxSizing: "border-box",
// // // // //     background: colors.backgroundAlt,
// // // // //     color: colors.text,
// // // // //   };

// // // // //   const textareaStyle = {
// // // // //     ...inputStyle,
// // // // //     minHeight: "100px",
// // // // //     resize: "vertical",
// // // // //   };

// // // // //   const submitButtonStyle = {
// // // // //     width: "100%",
// // // // //     padding: "0.875rem",
// // // // //     background: colors.buttonPrimary,
// // // // //     color: colors.buttonText,
// // // // //     border: "none",
// // // // //     borderRadius: "0.5rem",
// // // // //     fontSize: "1rem",
// // // // //     fontWeight: "600",
// // // // //     cursor: isSubmitting ? "not-allowed" : "pointer",
// // // // //     transition: "all 0.3s ease",
// // // // //     opacity: isSubmitting ? 0.7 : 1,
// // // // //   };

// // // // //   return (
// // // // //     <>
// // // // //       <style>{`
// // // // //                 @keyframes fadeIn {
// // // // //                     from { opacity: 0; }
// // // // //                     to { opacity: 1; }
// // // // //                 }
// // // // //                 @keyframes slideUp {
// // // // //                     from {
// // // // //                         opacity: 0;
// // // // //                         transform: translateY(20px);
// // // // //                     }
// // // // //                     to {
// // // // //                         opacity: 1;
// // // // //                         transform: translateY(0);
// // // // //                     }
// // // // //                 }
// // // // //                 .modal-input:focus {
// // // // //                     outline: none;
// // // // //                     border-color: ${colors.primary};
// // // // //                     box-shadow: 0 0 0 3px ${colors.primary}33;
// // // // //                 }
// // // // //                 .modal-submit-btn:hover:not(:disabled) {
// // // // //                     transform: translateY(-2px);
// // // // //                     box-shadow: 0 4px 12px ${colors.primary}4D;
// // // // //                 }
// // // // //                 .modal-close-btn:hover {
// // // // //                     background: ${colors.hover};
// // // // //                     color: ${colors.text};
// // // // //                 }
// // // // //             `}</style>
// // // // //       <div style={modalOverlayStyle} onClick={onClose}>
// // // // //         <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
// // // // //           <button
// // // // //             style={closeButtonStyle}
// // // // //             onClick={onClose}
// // // // //             className="modal-close-btn"
// // // // //             aria-label="Close modal"
// // // // //           >
// // // // //             ×
// // // // //           </button>

// // // // //           <h2
// // // // //             style={{
// // // // //               fontSize: "1.75rem",
// // // // //               fontWeight: "700",
// // // // //               color: colors.text,
// // // // //               marginBottom: "0.5rem",
// // // // //               marginTop: "0",
// // // // //             }}
// // // // //           >
// // // // //             Student Registration
// // // // //           </h2>
// // // // //           <p
// // // // //             style={{
// // // // //               color: colors.textSecondary,
// // // // //               marginBottom: "2rem",
// // // // //               fontSize: "0.95rem",
// // // // //             }}
// // // // //           >
// // // // //             Fill in the form below to register as a student
// // // // //           </p>

// // // // //           <form onSubmit={handleSubmit}>
// // // // //             <div style={formGroupStyle}>
// // // // //               <label style={labelStyle}>
// // // // //                 Branch <span style={{ color: "#ef4444" }}>*</span>
// // // // //               </label>
// // // // //               <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
// // // // //                 <label
// // // // //                   style={{
// // // // //                     display: "flex",
// // // // //                     alignItems: "center",
// // // // //                     gap: "0.5rem",
// // // // //                     color: colors.text,
// // // // //                   }}
// // // // //                 >
// // // // //                   <input
// // // // //                     type="radio"
// // // // //                     name="branchRadio"
// // // // //                     value="Commerce"
// // // // //                     checked={branchChoice === "Commerce"}
// // // // //                     onChange={() => setBranchChoice("Commerce")}
// // // // //                     required
// // // // //                   />
// // // // //                   <span>Commerce</span>
// // // // //                 </label>
// // // // //                 <label
// // // // //                   style={{
// // // // //                     display: "flex",
// // // // //                     alignItems: "center",
// // // // //                     gap: "0.5rem",
// // // // //                     color: colors.text,
// // // // //                   }}
// // // // //                 >
// // // // //                   <input
// // // // //                     type="radio"
// // // // //                     name="branchRadio"
// // // // //                     value="Science"
// // // // //                     checked={branchChoice === "Science"}
// // // // //                     onChange={() => setBranchChoice("Science")}
// // // // //                     required
// // // // //                   />
// // // // //                   <span>Science</span>
// // // // //                 </label>
// // // // //                 <label
// // // // //                   style={{
// // // // //                     display: "flex",
// // // // //                     alignItems: "center",
// // // // //                     gap: "0.5rem",
// // // // //                     color: colors.text,
// // // // //                   }}
// // // // //                 >
// // // // //                   <input
// // // // //                     type="radio"
// // // // //                     name="branchRadio"
// // // // //                     value="Other"
// // // // //                     checked={branchChoice === "Other"}
// // // // //                     onChange={() => setBranchChoice("Other")}
// // // // //                     required
// // // // //                   />
// // // // //                   <span>Other</span>
// // // // //                 </label>
// // // // //               </div>
// // // // //               {branchChoice === "Other" && (
// // // // //                 <div>
// // // // //                   <input
// // // // //                     type="text"
// // // // //                     name="branchOther"
// // // // //                     value={branchOther}
// // // // //                     onChange={(e) => setBranchOther(e.target.value)}
// // // // //                     style={{ ...inputStyle, marginTop: "0.75rem" }}
// // // // //                     className="modal-input"
// // // // //                     required
// // // // //                     placeholder="Enter branch"
// // // // //                   />
// // // // //                 </div>
// // // // //               )}
// // // // //             </div>
// // // // //             <div style={formGroupStyle}>
// // // // //               <label style={labelStyle} htmlFor="studentName">
// // // // //                 Student Name <span style={{ color: "#ef4444" }}>*</span>
// // // // //               </label>
// // // // //               <input
// // // // //                 type="text"
// // // // //                 id="studentName"
// // // // //                 name="studentName"
// // // // //                 value={formData.studentName}
// // // // //                 onChange={handleChange}
// // // // //                 style={inputStyle}
// // // // //                 className="modal-input"
// // // // //                 required
// // // // //                 placeholder="Enter student name"
// // // // //               />
// // // // //             </div>

// // // // //             <div style={formGroupStyle}>
// // // // //               <label style={labelStyle} htmlFor="schoolName">
// // // // //                 School Name <span style={{ color: "#ef4444" }}>*</span>
// // // // //               </label>
// // // // //               <input
// // // // //                 type="text"
// // // // //                 id="schoolName"
// // // // //                 name="schoolName"
// // // // //                 value={formData.schoolName}
// // // // //                 onChange={handleChange}
// // // // //                 style={inputStyle}
// // // // //                 className="modal-input"
// // // // //                 required
// // // // //                 placeholder="Enter school name"
// // // // //               />
// // // // //             </div>

// // // // //             <div style={formGroupStyle}>
// // // // //               <label style={labelStyle} htmlFor="villageOrCity">
// // // // //                 Village or City <span style={{ color: "#ef4444" }}>*</span>
// // // // //               </label>
// // // // //               <input
// // // // //                 type="text"
// // // // //                 id="villageOrCity"
// // // // //                 name="villageOrCity"
// // // // //                 value={formData.villageOrCity}
// // // // //                 onChange={handleChange}
// // // // //                 style={inputStyle}
// // // // //                 className="modal-input"
// // // // //                 required
// // // // //                 placeholder="Enter village or city"
// // // // //               />
// // // // //             </div>

// // // // //             <div style={formGroupStyle}>
// // // // //               <label style={labelStyle} htmlFor="address">
// // // // //                 Address <span style={{ color: "#ef4444" }}>*</span>
// // // // //               </label>
// // // // //               <textarea
// // // // //                 id="address"
// // // // //                 name="address"
// // // // //                 value={formData.address}
// // // // //                 onChange={handleChange}
// // // // //                 style={textareaStyle}
// // // // //                 className="modal-input"
// // // // //                 required
// // // // //                 placeholder="Enter full address"
// // // // //               />
// // // // //             </div>

// // // // //             <div style={formGroupStyle}>
// // // // //               <label style={labelStyle} htmlFor="mobileNumber">
// // // // //                 Mobile Number <span style={{ color: "#ef4444" }}>*</span>
// // // // //               </label>
// // // // //               <input
// // // // //                 type="tel"
// // // // //                 id="mobileNumber"
// // // // //                 name="mobileNumber"
// // // // //                 value={formData.mobileNumber}
// // // // //                 onChange={handleChange}
// // // // //                 style={inputStyle}
// // // // //                 className="modal-input"
// // // // //                 required
// // // // //                 placeholder="Enter mobile number"
// // // // //                 pattern="[0-9]{10}"
// // // // //                 maxLength="10"
// // // // //               />
// // // // //             </div>

// // // // //             <button
// // // // //               type="submit"
// // // // //               style={submitButtonStyle}
// // // // //               className="modal-submit-btn"
// // // // //               disabled={isSubmitting}
// // // // //             >
// // // // //               {isSubmitting ? "Submitting..." : "Submit Registration"}
// // // // //             </button>
// // // // //           </form>
// // // // //         </div>
// // // // //       </div>
// // // // //     </>
// // // // //   );
// // // // // };

// // // // // export default RegistrationModal;
// // // // // RegistrationModal.js
// // // // import React, { useState } from "react";
// // // // import axios from "axios";
// // // // import Swal from "sweetalert2";
// // // // import { useTheme } from "../context/ThemeContext";

// // // // const RegistrationModal = ({ isOpen, onClose }) => {
// // // //   const { colors } = useTheme();
// // // //   const [formData, setFormData] = useState({
// // // //     branch: "",
// // // //     studentName: "",
// // // //     schoolName: "",
// // // //     villageOrCity: "",
// // // //     address: "",
// // // //     mobileNumber: "",
// // // //   });
// // // //   const [branchChoice, setBranchChoice] = useState(""); // 'Commerce' | 'Science' | 'Other'
// // // //   const [branchOther, setBranchOther] = useState("");
// // // //   const [isSubmitting, setIsSubmitting] = useState(false);

// // // //   const handleChange = (e) => {
// // // //     setFormData({
// // // //       ...formData,
// // // //       [e.target.name]: e.target.value,
// // // //     });
// // // //   };

// // // //   const handleSubmit = async (e) => {
// // // //     e.preventDefault();
// // // //     setIsSubmitting(true);

// // // //     try {
// // // //       const finalBranch =
// // // //         branchChoice === "Other" ? (branchOther || "").trim() : branchChoice;
// // // //       const payload = { ...formData, branch: finalBranch };
// // // //       const response = await axios.post(
// // // //         "https://gurukulschools.org/api/api/public/student-registration",
// // // //         payload
// // // //       );

// // // //       if (response.status === 200) {
// // // //         Swal.fire({
// // // //           icon: "success",
// // // //           title: "Registration Successful!",
// // // //           text: "Your registration has been submitted successfully. We will contact you soon.",
// // // //           confirmButtonColor: "#0ea5e9",
// // // //           confirmButtonText: "OK",
// // // //         });

// // // //         // Reset form
// // // //         setFormData({
// // // //           branch: "",
// // // //           studentName: "",
// // // //           schoolName: "",
// // // //           villageOrCity: "",
// // // //           address: "",
// // // //           mobileNumber: "",
// // // //         });
// // // //         setBranchChoice("");
// // // //         setBranchOther("");

// // // //         onClose();
// // // //       }
// // // //     } catch (error) {
// // // //       Swal.fire({
// // // //         icon: "error",
// // // //         title: "Registration Failed",
// // // //         text:
// // // //           error.response?.data?.message ||
// // // //           "Something went wrong. Please try again.",
// // // //         confirmButtonColor: "#ef4444",
// // // //         confirmButtonText: "OK",
// // // //       });
// // // //     } finally {
// // // //       setIsSubmitting(false);
// // // //     }
// // // //   };

// // // //   if (!isOpen) return null;

// // // //   const modalOverlayStyle = {
// // // //     position: "fixed",
// // // //     top: 0,
// // // //     left: 0,
// // // //     right: 0,
// // // //     bottom: 0,
// // // //     background:
// // // //       "linear-gradient(180deg, rgba(2,6,23,0.5) 0%, rgba(2,6,23,0.6) 100%)",
// // // //     display: "flex",
// // // //     alignItems: "center",
// // // //     justifyContent: "center",
// // // //     zIndex: 2000,
// // // //     padding: "1rem",
// // // //     animation: "fadeIn 0.28s ease-in-out",
// // // //   };

// // // //   const modalContentStyle = {
// // // //     background: colors.card,
// // // //     borderRadius: "1rem",
// // // //     padding: "1.5rem",
// // // //     maxWidth: "900px",
// // // //     width: "100%",
// // // //     maxHeight: "92vh",
// // // //     overflowY: "auto",
// // // //     boxShadow: "0 20px 50px rgba(2,6,23,0.45)",
// // // //     position: "relative",
// // // //     animation: "slideUp 0.28s ease-in-out",
// // // //     display: "grid",
// // // //     gridTemplateColumns: "1fr 1fr",
// // // //     gap: "1.25rem",
// // // //   };

// // // //   const closeButtonStyle = {
// // // //     position: "absolute",
// // // //     top: "0.75rem",
// // // //     right: "0.75rem",
// // // //     background: "none",
// // // //     border: "none",
// // // //     fontSize: "1.5rem",
// // // //     cursor: "pointer",
// // // //     color: colors.textSecondary,
// // // //     width: "36px",
// // // //     height: "36px",
// // // //     display: "flex",
// // // //     alignItems: "center",
// // // //     justifyContent: "center",
// // // //     borderRadius: "50%",
// // // //     transition: "all 0.2s ease",
// // // //   };

// // // //   const leftPanelStyle = {
// // // //     display: "flex",
// // // //     flexDirection: "column",
// // // //     gap: "1rem",
// // // //     padding: "1rem",
// // // //     borderRadius: "0.75rem",
// // // //     alignItems: "flex-start",
// // // //     justifyContent: "center",
// // // //     background: `linear-gradient(135deg, ${colors.primary}20, ${colors.primary}10)`,
// // // //     minHeight: "180px",
// // // //   };

// // // //   const headingStyle = {
// // // //     fontSize: "1.6rem",
// // // //     fontWeight: "800",
// // // //     margin: 0,
// // // //     color: colors.text,
// // // //     lineHeight: 1.1,
// // // //   };

// // // //   const subTextStyle = {
// // // //     color: colors.textSecondary,
// // // //     fontSize: "0.95rem",
// // // //     margin: 0,
// // // //   };

// // // //   const formContainerStyle = {
// // // //     padding: "0.4rem 0",
// // // //   };

// // // //   const formGroupStyle = {
// // // //     marginBottom: "1rem",
// // // //   };

// // // //   const labelStyle = {
// // // //     display: "block",
// // // //     marginBottom: "0.35rem",
// // // //     color: colors.text,
// // // //     fontWeight: "600",
// // // //     fontSize: "0.95rem",
// // // //   };

// // // //   const inputStyle = {
// // // //     width: "100%",
// // // //     padding: "0.75rem",
// // // //     border: `1px solid ${colors.border}`,
// // // //     borderRadius: "0.5rem",
// // // //     fontSize: "1rem",
// // // //     fontFamily: "inherit",
// // // //     transition: "border-color 0.2s ease",
// // // //     boxSizing: "border-box",
// // // //     background: colors.backgroundAlt,
// // // //     color: colors.text,
// // // //   };

// // // //   const textareaStyle = {
// // // //     ...inputStyle,
// // // //     minHeight: "96px",
// // // //     resize: "vertical",
// // // //   };

// // // //   const submitButtonStyle = {
// // // //     width: "100%",
// // // //     padding: "0.95rem",
// // // //     background: `linear-gradient(90deg, ${colors.primary}, ${colors.primary})`,
// // // //     color: colors.buttonText,
// // // //     border: "none",
// // // //     borderRadius: "0.6rem",
// // // //     fontSize: "1rem",
// // // //     fontWeight: "700",
// // // //     cursor: isSubmitting ? "not-allowed" : "pointer",
// // // //     transition: "all 0.22s ease",
// // // //     opacity: isSubmitting ? 0.8 : 1,
// // // //     boxShadow: `0 8px 30px ${colors.primary}33`,
// // // //   };

// // // //   return (
// // // //     <>
// // // //       <style>{`
// // // //         @keyframes fadeIn {
// // // //             from { opacity: 0; }
// // // //             to { opacity: 1; }
// // // //         }
// // // //         @keyframes slideUp {
// // // //             from {
// // // //                 opacity: 0;
// // // //                 transform: translateY(20px);
// // // //             }
// // // //             to {
// // // //                 opacity: 1;
// // // //                 transform: translateY(0);
// // // //             }
// // // //         }
// // // //         .modal-input:focus {
// // // //             outline: none;
// // // //             border-color: ${colors.primary};
// // // //             box-shadow: 0 0 0 4px ${colors.primary}22;
// // // //         }
// // // //         .modal-submit-btn:hover:not(:disabled) {
// // // //             transform: translateY(-2px);
// // // //             box-shadow: 0 8px 40px ${colors.primary}33;
// // // //         }
// // // //         .modal-close-btn:hover {
// // // //             background: ${colors.hover};
// // // //             color: ${colors.text};
// // // //         }

// // // //         /* Responsive behavior */
// // // //         @media (max-width: 820px) {
// // // //             .registration-modal-content {
// // // //                 grid-template-columns: 1fr !important;
// // // //                 padding: 1rem !important;
// // // //                 border-radius: 0.75rem !important;
// // // //                 height: auto !important;
// // // //             }
// // // //             .registration-left-panel {
// // // //                 display: flex;
// // // //                 flex-direction: row;
// // // //                 gap: 0.75rem;
// // // //                 align-items: center;
// // // //                 padding: 0.75rem !important;
// // // //             }
// // // //         }
// // // //         @media (max-width: 480px) {
// // // //             .registration-modal-content {
// // // //                 max-width: 100% !important;
// // // //                 width: 100% !important;
// // // //                 height: 100% !important;
// // // //                 border-radius: 0 !important;
// // // //                 padding: 0.75rem !important;
// // // //             }
// // // //             .registration-left-panel {
// // // //                 display: none;
// // // //             }
// // // //         }
// // // //       `}</style>

// // // //       <div style={modalOverlayStyle} onClick={onClose}>
// // // //         <div
// // // //           className="registration-modal-content"
// // // //           style={modalContentStyle}
// // // //           onClick={(e) => e.stopPropagation()}
// // // //         >
// // // //           <div className="registration-left-panel" style={leftPanelStyle}>
// // // //             <div style={{ padding: "0.25rem 0" }}>
// // // //               <h2 style={headingStyle}>Join Gurukul</h2>
// // // //               <p style={subTextStyle}>
// // // //                 Fast-track your admission — register now and our admissions team
// // // //                 will contact you with next steps.
// // // //               </p>
// // // //             </div>
// // // //             <div
// // // //               style={{
// // // //                 marginTop: "0.5rem",
// // // //                 fontSize: "0.85rem",
// // // //                 color: colors.textSecondary,
// // // //               }}
// // // //             >
// // // //               <strong>Why register?</strong>
// // // //               <ul
// // // //                 style={{
// // // //                   margin: "0.4rem 0 0 1rem",
// // // //                   padding: 0,
// // // //                 }}
// // // //               >
// // // //                 <li>Priority communication</li>
// // // //                 <li>Assistance with documents</li>
// // // //                 <li>Fee & scholarship guidance</li>
// // // //               </ul>
// // // //             </div>
// // // //           </div>

// // // //           <div style={formContainerStyle}>
// // // //             <button
// // // //               style={closeButtonStyle}
// // // //               onClick={onClose}
// // // //               className="modal-close-btn"
// // // //               aria-label="Close modal"
// // // //             >
// // // //               ×
// // // //             </button>

// // // //             <form onSubmit={handleSubmit}>
// // // //               <div
// // // //                 style={{
// // // //                   display: "grid",
// // // //                   gridTemplateColumns: "1fr 1fr",
// // // //                   gap: "0.75rem",
// // // //                 }}
// // // //               >
// // // //                 <div style={formGroupStyle}>
// // // //                   <label style={labelStyle}>
// // // //                     Branch <span style={{ color: "#ef4444" }}>*</span>
// // // //                   </label>
// // // //                   <div
// // // //                     style={{
// // // //                       display: "flex",
// // // //                       gap: "0.6rem",
// // // //                       flexWrap: "wrap",
// // // //                     }}
// // // //                   >
// // // //                     <label
// // // //                       style={{
// // // //                         display: "flex",
// // // //                         alignItems: "center",
// // // //                         gap: "0.4rem",
// // // //                         color: colors.text,
// // // //                       }}
// // // //                     >
// // // //                       <input
// // // //                         type="radio"
// // // //                         name="branchRadio"
// // // //                         value="Commerce"
// // // //                         checked={branchChoice === "Commerce"}
// // // //                         onChange={() => setBranchChoice("Commerce")}
// // // //                         required
// // // //                       />
// // // //                       <span>Commerce</span>
// // // //                     </label>

// // // //                     <label
// // // //                       style={{
// // // //                         display: "flex",
// // // //                         alignItems: "center",
// // // //                         gap: "0.4rem",
// // // //                         color: colors.text,
// // // //                       }}
// // // //                     >
// // // //                       <input
// // // //                         type="radio"
// // // //                         name="branchRadio"
// // // //                         value="Science"
// // // //                         checked={branchChoice === "Science"}
// // // //                         onChange={() => setBranchChoice("Science")}
// // // //                         required
// // // //                       />
// // // //                       <span>Science</span>
// // // //                     </label>

// // // //                     <label
// // // //                       style={{
// // // //                         display: "flex",
// // // //                         alignItems: "center",
// // // //                         gap: "0.4rem",
// // // //                         color: colors.text,
// // // //                       }}
// // // //                     >
// // // //                       <input
// // // //                         type="radio"
// // // //                         name="branchRadio"
// // // //                         value="Other"
// // // //                         checked={branchChoice === "Other"}
// // // //                         onChange={() => setBranchChoice("Other")}
// // // //                         required
// // // //                       />
// // // //                       <span>Other</span>
// // // //                     </label>
// // // //                   </div>

// // // //                   {branchChoice === "Other" && (
// // // //                     <input
// // // //                       type="text"
// // // //                       name="branchOther"
// // // //                       value={branchOther}
// // // //                       onChange={(e) => setBranchOther(e.target.value)}
// // // //                       style={{ ...inputStyle, marginTop: "0.5rem" }}
// // // //                       className="modal-input"
// // // //                       required
// // // //                       placeholder="Enter branch"
// // // //                     />
// // // //                   )}
// // // //                 </div>

// // // //                 <div style={formGroupStyle}>
// // // //                   <label style={labelStyle} htmlFor="studentName">
// // // //                     Student Full Name{" "}
// // // //                     <span style={{ color: "#ef4444" }}>*</span>
// // // //                   </label>
// // // //                   <input
// // // //                     type="text"
// // // //                     id="studentName"
// // // //                     name="studentName"
// // // //                     value={formData.studentName}
// // // //                     onChange={handleChange}
// // // //                     style={inputStyle}
// // // //                     className="modal-input"
// // // //                     required
// // // //                     placeholder="Enter student's full name"
// // // //                   />
// // // //                 </div>
// // // //               </div>

// // // //               <div
// // // //                 style={{
// // // //                   display: "grid",
// // // //                   gridTemplateColumns: "1fr 1fr",
// // // //                   gap: "0.75rem",
// // // //                 }}
// // // //               >
// // // //                 <div style={formGroupStyle}>
// // // //                   <label style={labelStyle} htmlFor="schoolName">
// // // //                     School Name <span style={{ color: "#ef4444" }}>*</span>
// // // //                   </label>
// // // //                   <input
// // // //                     type="text"
// // // //                     id="schoolName"
// // // //                     name="schoolName"
// // // //                     value={formData.schoolName}
// // // //                     onChange={handleChange}
// // // //                     style={inputStyle}
// // // //                     className="modal-input"
// // // //                     required
// // // //                     placeholder="Enter school name"
// // // //                   />
// // // //                 </div>

// // // //                 <div style={formGroupStyle}>
// // // //                   <label style={labelStyle} htmlFor="villageOrCity">
// // // //                     Village or City <span style={{ color: "#ef4444" }}>*</span>
// // // //                   </label>
// // // //                   <input
// // // //                     type="text"
// // // //                     id="villageOrCity"
// // // //                     name="villageOrCity"
// // // //                     value={formData.villageOrCity}
// // // //                     onChange={handleChange}
// // // //                     style={inputStyle}
// // // //                     className="modal-input"
// // // //                     required
// // // //                     placeholder="Enter village or city"
// // // //                   />
// // // //                 </div>
// // // //               </div>

// // // //               <div style={formGroupStyle}>
// // // //                 <label style={labelStyle} htmlFor="address">
// // // //                   Address <span style={{ color: "#ef4444" }}>*</span>
// // // //                 </label>
// // // //                 <textarea
// // // //                   id="address"
// // // //                   name="address"
// // // //                   value={formData.address}
// // // //                   onChange={handleChange}
// // // //                   style={textareaStyle}
// // // //                   className="modal-input"
// // // //                   required
// // // //                   placeholder="Enter full address"
// // // //                 />
// // // //               </div>

// // // //               <div style={formGroupStyle}>
// // // //                 <label style={labelStyle} htmlFor="mobileNumber">
// // // //                   Mobile Number <span style={{ color: "#ef4444" }}>*</span>
// // // //                 </label>
// // // //                 <input
// // // //                   type="tel"
// // // //                   id="mobileNumber"
// // // //                   name="mobileNumber"
// // // //                   value={formData.mobileNumber}
// // // //                   onChange={handleChange}
// // // //                   style={inputStyle}
// // // //                   className="modal-input"
// // // //                   required
// // // //                   placeholder="Enter mobile number"
// // // //                   pattern="[0-9]{10}"
// // // //                   maxLength="10"
// // // //                 />
// // // //               </div>

// // // //               <div style={{ marginTop: "0.5rem" }}>
// // // //                 <button
// // // //                   type="submit"
// // // //                   style={submitButtonStyle}
// // // //                   className="modal-submit-btn"
// // // //                   disabled={isSubmitting}
// // // //                 >
// // // //                   {isSubmitting ? "Submitting..." : "Submit Registration"}
// // // //                 </button>
// // // //               </div>
// // // //             </form>
// // // //           </div>
// // // //         </div>
// // // //       </div>
// // // //     </>
// // // //   );
// // // // };

// // // // export default RegistrationModal;
// // // import React, { useEffect, useState } from "react";
// // // import axios from "axios";
// // // import Swal from "sweetalert2";
// // // import { useTheme } from "../context/ThemeContext";

// // // const RegistrationModal = ({ isOpen, onClose }) => {
// // //   const { colors } = useTheme();
// // //   const [formData, setFormData] = useState({
// // //     branch: "",
// // //     studentName: "",
// // //     schoolName: "",
// // //     villageOrCity: "",
// // //     address: "",
// // //     mobileNumber: "",
// // //   });
// // //   const [branchChoice, setBranchChoice] = useState("");
// // //   const [branchOther, setBranchOther] = useState("");
// // //   const [isSubmitting, setIsSubmitting] = useState(false);

// // //   useEffect(() => {
// // //     if (!isOpen) return;
// // //     const onKey = (e) => {
// // //       if (e.key === "Escape") onClose();
// // //     };
// // //     window.addEventListener("keydown", onKey);
// // //     return () => window.removeEventListener("keydown", onKey);
// // //   }, [isOpen, onClose]);

// // //   const handleChange = (e) =>
// // //     setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setIsSubmitting(true);
// // //     try {
// // //       const finalBranch =
// // //         branchChoice === "Other" ? (branchOther || "").trim() : branchChoice;
// // //       const payload = { ...formData, branch: finalBranch };
// // //       const response = await axios.post(
// // //         "https://gurukulschools.org/api/api/public/student-registration",
// // //         payload
// // //       );

// // //       if (response.status === 200) {
// // //         Swal.fire({
// // //           icon: "success",
// // //           title: "Registration Successful!",
// // //           text: "Your registration has been submitted successfully. We will contact you soon.",
// // //           confirmButtonColor: "#0ea5e9",
// // //           confirmButtonText: "OK",
// // //         });

// // //         setFormData({
// // //           branch: "",
// // //           studentName: "",
// // //           schoolName: "",
// // //           villageOrCity: "",
// // //           address: "",
// // //           mobileNumber: "",
// // //         });
// // //         setBranchChoice("");
// // //         setBranchOther("");
// // //         onClose();
// // //       } else {
// // //         throw new Error("Unexpected response");
// // //       }
// // //     } catch (error) {
// // //       Swal.fire({
// // //         icon: "error",
// // //         title: "Registration Failed",
// // //         text:
// // //           error.response?.data?.message ||
// // //           error.message ||
// // //           "Something went wrong. Please try again.",
// // //         confirmButtonColor: "#ef4444",
// // //         confirmButtonText: "OK",
// // //       });
// // //     } finally {
// // //       setIsSubmitting(false);
// // //     }
// // //   };

// // //   if (!isOpen) return null;

// // //   const overlay = {
// // //     position: "fixed",
// // //     inset: 0,
// // //     background:
// // //       "linear-gradient(180deg, rgba(2,6,23,0.5) 0%, rgba(2,6,23,0.6) 100%)",
// // //     display: "flex",
// // //     alignItems: "center",
// // //     justifyContent: "center",
// // //     zIndex: 2000,
// // //     padding: "1rem",
// // //     WebkitOverflowScrolling: "touch",
// // //   };

// // //   const closeButtonStyle = {
// // //     position: "absolute",
// // //     top: "0.6rem",
// // //     right: "0.6rem",
// // //     background: "none",
// // //     border: "none",
// // //     fontSize: "1.4rem",
// // //     cursor: "pointer",
// // //     color: colors.textSecondary,
// // //     width: "36px",
// // //     height: "36px",
// // //     display: "flex",
// // //     alignItems: "center",
// // //     justifyContent: "center",
// // //     borderRadius: "50%",
// // //   };

// // //   const inputBaseStyle = {
// // //     width: "100%",
// // //     padding: "0.75rem",
// // //     border: `1px solid ${colors.border}`,
// // //     borderRadius: "0.5rem",
// // //     fontSize: "1rem",
// // //     fontFamily: "inherit",
// // //     transition: "border-color 0.15s ease",
// // //     boxSizing: "border-box",
// // //     background: colors.backgroundAlt,
// // //     color: colors.text,
// // //   };

// // //   return (
// // //     <>
// // //       <style>{`
// // //         @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
// // //         @keyframes slideUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }

// // //         /* Entire modal container scrolls when content overflows */
// // //         .registration-modal-container {
// // //           width: 100%;
// // //           max-width: 1000px;
// // //           max-height: calc(100vh - 48px);
// // //           overflow: auto; /* <- whole panel scrolls */
// // //           -webkit-overflow-scrolling: touch;
// // //           border-radius: 14px;
// // //           box-shadow: 0 20px 60px rgba(2,6,23,0.45);
// // //           display: grid;
// // //           grid-template-columns: 420px 1fr; /* left column fixed-ish, right flexible */
// // //           gap: 1.25rem;
// // //           padding: 1.15rem;
// // //           background: ${colors.card};
// // //           position: relative;
// // //           animation: slideUp 0.22s ease-in-out;
// // //         }

// // //         /* subtle scrollbar for the whole modal */
// // //         .registration-modal-container::-webkit-scrollbar { width: 10px; height: 10px; }
// // //         .registration-modal-container::-webkit-scrollbar-track { background: transparent; }
// // //         .registration-modal-container::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.08); border-radius: 12px; border: 2px solid transparent; background-clip: padding-box; }
// // //         .registration-modal-container { scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.08) transparent; }

// // //         /* Left promo */
// // //         .registration-left-panel {
// // //           padding: 1rem;
// // //           border-radius: 10px;
// // //           display: flex;
// // //           flex-direction: column;
// // //           gap: 0.9rem;
// // //           justify-content: center;
// // //           align-items: flex-start;
// // //           min-height: 220px;
// // //           background: linear-gradient(135deg, ${colors.primary}22, ${colors.primary}08);
// // //         }
// // //         .get-badge { display:inline-block; font-weight:800; padding:0.32rem 0.55rem; border-radius:999px; font-size:0.86rem; background:${colors.backgroundAlt}; color:${colors.text}; border:1px solid ${colors.border}; }

// // //         /* Form area (not separately scrollable now) */
// // //         .registration-form-panel { padding: 0.15rem 0; min-height: 220px; }

// // //         .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
// // //         .form-group { margin-bottom: 1rem; }
// // //         label.modal-label { display:block; margin-bottom:0.35rem; color: ${colors.text}; font-weight:600; font-size:0.95rem; }
// // //         .modal-input:focus { outline:none; border-color: ${colors.primary}; box-shadow: 0 0 0 6px ${colors.primary}18; }

// // //         .modal-submit-btn { width:100%; padding:0.95rem; background: linear-gradient(90deg, ${colors.primary}, ${colors.primary}); color:${colors.buttonText}; border:none; border-radius:0.6rem; font-weight:700; cursor:pointer; box-shadow: 0 8px 30px ${colors.primary}22; }
// // //         .modal-submit-btn:disabled { opacity:0.75; cursor:not-allowed; }

// // //         .radio-row { display:flex; gap:0.6rem; flex-wrap:wrap; align-items:center; }
// // //         .radio-row label { display:flex; align-items:center; gap:0.45rem; color:${colors.text}; cursor:pointer; padding:0.18rem 0.2rem; border-radius:6px; }

// // //         /* STACK on smaller screens: left panel above form */
// // //         @media (max-width: 920px) {
// // //           .registration-modal-container { grid-template-columns: 1fr; padding: 0.9rem; gap: 0.9rem; max-width: 760px; }
// // //           .form-grid { grid-template-columns: 1fr; }
// // //           .registration-left-panel { order: -1; min-height: auto; }
// // //         }
// // //         @media (max-width: 480px) {
// // //           .registration-modal-container { max-width:100%; width:100%; height:100%; border-radius:0; padding:0.6rem; max-height:100vh; }
// // //           .registration-left-panel { padding:0.75rem; border-radius:8px; }
// // //           .modal-close-btn { top:0.45rem; right:0.45rem; }
// // //         }

// // //       `}</style>

// // //       <div style={overlay} onClick={onClose}>
// // //         <div
// // //           className="registration-modal-container"
// // //           onClick={(e) => e.stopPropagation()}
// // //           role="dialog"
// // //           aria-modal="true"
// // //         >
// // //           {/* Close button sits inside the container so it scrolls away with content if desired */}
// // //           <button
// // //             style={closeButtonStyle}
// // //             onClick={onClose}
// // //             className="modal-close-btn"
// // //             aria-label="Close modal"
// // //           >
// // //             ×
// // //           </button>

// // //           {/* LEFT PROMO */}
// // //           <div className="registration-left-panel" aria-hidden={false}>
// // //             <div
// // //               style={{ display: "flex", gap: "0.6rem", alignItems: "center" }}
// // //             >
// // //               <span className="get-badge">G E T</span>
// // //               <div style={{ display: "flex", flexDirection: "column" }}>
// // //                 <strong style={{ fontSize: "0.98rem", color: colors.text }}>
// // //                   Gurukul Entrance Test
// // //                 </strong>
// // //                 <small style={{ color: colors.textSecondary, marginTop: 2 }}>
// // //                   APPLY FOR 2026
// // //                 </small>
// // //               </div>
// // //             </div>

// // //             <h2
// // //               style={{
// // //                 margin: 0,
// // //                 color: colors.text,
// // //                 fontSize: "1.45rem",
// // //                 fontWeight: 800,
// // //               }}
// // //             >
// // //               G E T 2026
// // //             </h2>
// // //             <p style={{ margin: 0, color: colors.textSecondary }}>
// // //               For students entering <strong>11th / 12th</strong> — coaching for{" "}
// // //               <strong>JEE • NEET</strong> (Science) and{" "}
// // //               <strong>CA Foundation</strong> (Commerce).
// // //             </p>

// // //             <div style={{ marginTop: 8, color: colors.textSecondary }}>
// // //               <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
// // //                 <li>Golden opportunity for Science & Commerce aspirants</li>
// // //                 <li>
// // //                   Specialized JEE / NEET guidance and CA Foundation coaching
// // //                 </li>
// // //                 <li>
// // //                   <strong>100% scholarship</strong> for qualified students
// // //                 </li>
// // //                 <li>Limited seats — priority for early registrants</li>
// // //               </ul>
// // //             </div>

// // //             <div style={{ marginTop: 8 }}>
// // //               <small style={{ color: colors.textSecondary }}>
// // //                 Register now and our admissions team will contact you with next
// // //                 steps and test details.
// // //               </small>
// // //             </div>
// // //           </div>

// // //           {/* RIGHT: form (now part of the same scrollable container) */}
// // //           <div className="registration-form-panel">
// // //             <form onSubmit={handleSubmit}>
// // //               <div className="form-grid">
// // //                 <div className="form-group">
// // //                   <label className="modal-label">
// // //                     Branch <span style={{ color: "#ef4444" }}>*</span>
// // //                   </label>
// // //                   <div
// // //                     className="radio-row"
// // //                     role="radiogroup"
// // //                     aria-label="Branch choice"
// // //                   >
// // //                     <label>
// // //                       <input
// // //                         type="radio"
// // //                         name="branchRadio"
// // //                         value="Commerce"
// // //                         checked={branchChoice === "Commerce"}
// // //                         onChange={() => setBranchChoice("Commerce")}
// // //                         required
// // //                       />
// // //                       <span>Commerce</span>
// // //                     </label>
// // //                     <label>
// // //                       <input
// // //                         type="radio"
// // //                         name="branchRadio"
// // //                         value="Science"
// // //                         checked={branchChoice === "Science"}
// // //                         onChange={() => setBranchChoice("Science")}
// // //                         required
// // //                       />
// // //                       <span>Science</span>
// // //                     </label>
// // //                     <label>
// // //                       <input
// // //                         type="radio"
// // //                         name="branchRadio"
// // //                         value="Other"
// // //                         checked={branchChoice === "Other"}
// // //                         onChange={() => setBranchChoice("Other")}
// // //                         required
// // //                       />
// // //                       <span>Other</span>
// // //                     </label>
// // //                   </div>

// // //                   {branchChoice === "Other" && (
// // //                     <input
// // //                       type="text"
// // //                       name="branchOther"
// // //                       value={branchOther}
// // //                       onChange={(e) => setBranchOther(e.target.value)}
// // //                       style={{ ...inputBaseStyle, marginTop: "0.6rem" }}
// // //                       className="modal-input"
// // //                       required
// // //                       placeholder="Enter branch"
// // //                     />
// // //                   )}
// // //                 </div>

// // //                 <div className="form-group">
// // //                   <label className="modal-label" htmlFor="studentName">
// // //                     Student Full Name{" "}
// // //                     <span style={{ color: "#ef4444" }}>*</span>
// // //                   </label>
// // //                   <input
// // //                     id="studentName"
// // //                     name="studentName"
// // //                     type="text"
// // //                     value={formData.studentName}
// // //                     onChange={handleChange}
// // //                     style={inputBaseStyle}
// // //                     className="modal-input"
// // //                     required
// // //                     placeholder="Enter student's full name"
// // //                   />
// // //                 </div>
// // //               </div>

// // //               <div className="form-grid" style={{ marginTop: 8 }}>
// // //                 <div className="form-group">
// // //                   <label className="modal-label" htmlFor="schoolName">
// // //                     School Name <span style={{ color: "#ef4444" }}>*</span>
// // //                   </label>
// // //                   <input
// // //                     id="schoolName"
// // //                     name="schoolName"
// // //                     type="text"
// // //                     value={formData.schoolName}
// // //                     onChange={handleChange}
// // //                     style={inputBaseStyle}
// // //                     className="modal-input"
// // //                     required
// // //                     placeholder="Enter school name"
// // //                   />
// // //                 </div>

// // //                 <div className="form-group">
// // //                   <label className="modal-label" htmlFor="villageOrCity">
// // //                     Village or City <span style={{ color: "#ef4444" }}>*</span>
// // //                   </label>
// // //                   <input
// // //                     id="villageOrCity"
// // //                     name="villageOrCity"
// // //                     type="text"
// // //                     value={formData.villageOrCity}
// // //                     onChange={handleChange}
// // //                     style={inputBaseStyle}
// // //                     className="modal-input"
// // //                     required
// // //                     placeholder="Enter village or city"
// // //                   />
// // //                 </div>
// // //               </div>

// // //               <div className="form-group" style={{ marginTop: 8 }}>
// // //                 <label className="modal-label" htmlFor="address">
// // //                   Address <span style={{ color: "#ef4444" }}>*</span>
// // //                 </label>
// // //                 <textarea
// // //                   id="address"
// // //                   name="address"
// // //                   value={formData.address}
// // //                   onChange={handleChange}
// // //                   style={{
// // //                     ...inputBaseStyle,
// // //                     minHeight: "96px",
// // //                     resize: "vertical",
// // //                   }}
// // //                   className="modal-input"
// // //                   required
// // //                   placeholder="Enter full address"
// // //                 />
// // //               </div>

// // //               <div className="form-group">
// // //                 <label className="modal-label" htmlFor="mobileNumber">
// // //                   Mobile Number <span style={{ color: "#ef4444" }}>*</span>
// // //                 </label>
// // //                 <input
// // //                   id="mobileNumber"
// // //                   name="mobileNumber"
// // //                   type="tel"
// // //                   value={formData.mobileNumber}
// // //                   onChange={handleChange}
// // //                   style={inputBaseStyle}
// // //                   className="modal-input"
// // //                   required
// // //                   placeholder="Enter mobile number"
// // //                   pattern="[0-9]{10}"
// // //                   maxLength="10"
// // //                 />
// // //               </div>

// // //               <div style={{ marginTop: "0.75rem" }}>
// // //                 <button
// // //                   type="submit"
// // //                   className="modal-submit-btn"
// // //                   disabled={isSubmitting}
// // //                 >
// // //                   {isSubmitting ? "Submitting..." : "Submit Registration"}
// // //                 </button>
// // //               </div>

// // //               {/* padding at bottom so last element can scroll above bottom edge */}
// // //               <div style={{ height: 18 }} aria-hidden="true" />
// // //             </form>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </>
// // //   );
// // // };

// // // export default RegistrationModal;
// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import Swal from "sweetalert2";
// // import { useTheme } from "../context/ThemeContext";

// // const RegistrationModal = ({ isOpen, onClose }) => {
// //   const { colors } = useTheme();

// //   const [formData, setFormData] = useState({
// //     branch: "",
// //     studentName: "",
// //     schoolName: "",
// //     villageOrCity: "",
// //     address: "",
// //     mobileNumber: "",
// //     lastExamPercentage: "",
// //     emailId: "",
// //     interestedFor: "",
// //   });

// //   const [branchChoice, setBranchChoice] = useState("");
// //   const [branchOther, setBranchOther] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   useEffect(() => {
// //     if (!isOpen) return;
// //     const onKey = (e) => {
// //       if (e.key === "Escape") onClose();
// //     };
// //     window.addEventListener("keydown", onKey);
// //     return () => window.removeEventListener("keydown", onKey);
// //   }, [isOpen, onClose]);

// //   const handleChange = (e) =>
// //     setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

// //   // when branchChoice changes, update formData.branch and reset interestedFor
// //   useEffect(() => {
// //     setFormData((s) => ({
// //       ...s,
// //       branch: branchChoice === "Other" ? branchOther : branchChoice,
// //     }));
// //     // reset interestedFor when branch changes
// //     setFormData((s) => ({ ...s, interestedFor: "" }));
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [branchChoice, branchOther]);

// //   const validatePercentage = (val) => {
// //     if (val === "") return false;
// //     const n = Number(val);
// //     return !Number.isNaN(n) && n >= 0 && n <= 100;
// //   };

// //   const getInterestedOptions = () => {
// //     if (branchChoice === "Science") return ["CET", "JEE", "NEET"];
// //     if (branchChoice === "Commerce") return ["CA Foundation"];
// //     // Other / not chosen
// //     return ["CET", "JEE", "NEET", "CA Foundation"];
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     // client-side checks (all required except email)
// //     if (!branchChoice || (branchChoice === "Other" && !branchOther.trim())) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Missing field",
// //         text: "Please select/enter Branch.",
// //       });
// //     }
// //     if (!formData.studentName.trim()) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Missing field",
// //         text: "Please enter student's full name.",
// //       });
// //     }
// //     if (!formData.schoolName.trim()) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Missing field",
// //         text: "Please enter school name.",
// //       });
// //     }
// //     if (!formData.villageOrCity.trim()) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Missing field",
// //         text: "Please enter village or city.",
// //       });
// //     }
// //     if (!formData.address.trim()) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Missing field",
// //         text: "Please enter address.",
// //       });
// //     }
// //     if (!/^\d{10}$/.test(formData.mobileNumber)) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Invalid mobile",
// //         text: "Please enter a valid 10-digit mobile number.",
// //       });
// //     }
// //     if (!validatePercentage(formData.lastExamPercentage)) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Invalid percentage",
// //         text: "Please enter last exam percentage between 0 and 100.",
// //       });
// //     }
// //     if (!formData.interestedFor) {
// //       return Swal.fire({
// //         icon: "error",
// //         title: "Missing field",
// //         text: "Please select what you're interested for.",
// //       });
// //     }

// //     setIsSubmitting(true);

// //     try {
// //       const finalBranch =
// //         branchChoice === "Other" ? (branchOther || "").trim() : branchChoice;
// //       const payload = {
// //         ...formData,
// //         branch: finalBranch,
// //         // ensure lastExamPercentage is numeric
// //         lastExamPercentage: Number(formData.lastExamPercentage),
// //       };

// //       const response = await axios.post(
// //         "https://gurukulschools.org/api/api/public/student-registration",
// //         payload
// //       );

// //       if (response.status === 200) {
// //         Swal.fire({
// //           icon: "success",
// //           title: "Registration Successful!",
// //           text: "Your registration has been submitted successfully. We will contact you soon.",
// //           confirmButtonColor: "#0ea5e9",
// //           confirmButtonText: "OK",
// //         });

// //         // Reset form
// //         setFormData({
// //           branch: "",
// //           studentName: "",
// //           schoolName: "",
// //           villageOrCity: "",
// //           address: "",
// //           mobileNumber: "",
// //           lastExamPercentage: "",
// //           emailId: "",
// //           interestedFor: "",
// //         });
// //         setBranchChoice("");
// //         setBranchOther("");
// //         onClose();
// //       } else {
// //         throw new Error("Unexpected response");
// //       }
// //     } catch (error) {
// //       Swal.fire({
// //         icon: "error",
// //         title: "Registration Failed",
// //         text:
// //           error.response?.data?.message ||
// //           error.message ||
// //           "Something went wrong. Please try again.",
// //         confirmButtonColor: "#ef4444",
// //         confirmButtonText: "OK",
// //       });
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   if (!isOpen) return null;

// //   const overlay = {
// //     position: "fixed",
// //     inset: 0,
// //     background:
// //       "linear-gradient(180deg, rgba(2,6,23,0.5) 0%, rgba(2,6,23,0.6) 100%)",
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "center",
// //     zIndex: 2000,
// //     padding: "1rem",
// //     WebkitOverflowScrolling: "touch",
// //   };

// //   const closeButtonStyle = {
// //     position: "absolute",
// //     top: "0.6rem",
// //     right: "0.6rem",
// //     background: "none",
// //     border: "none",
// //     fontSize: "1.4rem",
// //     cursor: "pointer",
// //     color: colors.textSecondary,
// //     width: "36px",
// //     height: "36px",
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "center",
// //     borderRadius: "50%",
// //   };

// //   const inputBaseStyle = {
// //     width: "100%",
// //     padding: "0.75rem",
// //     border: `1px solid ${colors.border}`,
// //     borderRadius: "0.5rem",
// //     fontSize: "1rem",
// //     fontFamily: "inherit",
// //     transition: "border-color 0.15s ease",
// //     boxSizing: "border-box",
// //     background: colors.backgroundAlt,
// //     color: colors.text,
// //   };

// //   return (
// //     <>
// //       <style>{`
// //         @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
// //         @keyframes slideUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }

// //         /* Entire modal container scrolls when content overflows */
// //         .registration-modal-container {
// //           width: 100%;
// //           max-width: 1000px;
// //           max-height: calc(100vh - 48px);
// //           overflow: auto; /* whole panel scrolls */
// //           -webkit-overflow-scrolling: touch;
// //           border-radius: 14px;
// //           box-shadow: 0 20px 60px rgba(2,6,23,0.45);
// //           display: grid;
// //           grid-template-columns: 420px 1fr; /* left column fixed-ish, right flexible */
// //           gap: 1.25rem;
// //           padding: 1.15rem;
// //           background: ${colors.card};
// //           position: relative;
// //           animation: slideUp 0.22s ease-in-out;
// //         }

// //         .registration-modal-container::-webkit-scrollbar { width: 10px; height: 10px; }
// //         .registration-modal-container::-webkit-scrollbar-track { background: transparent; }
// //         .registration-modal-container::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.08); border-radius: 12px; border: 2px solid transparent; background-clip: padding-box; }
// //         .registration-modal-container { scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.08) transparent; }

// //         .registration-left-panel {
// //           padding: 1rem;
// //           border-radius: 10px;
// //           display: flex;
// //           flex-direction: column;
// //           gap: 0.9rem;
// //           justify-content: center;
// //           align-items: flex-start;
// //           min-height: 220px;
// //           background: linear-gradient(135deg, ${colors.primary}22, ${colors.primary}08);
// //         }
// //         .get-badge { display:inline-block; font-weight:800; padding:0.32rem 0.55rem; border-radius:999px; font-size:0.86rem; background:${colors.backgroundAlt}; color:${colors.text}; border:1px solid ${colors.border}; }

// //         .registration-form-panel { padding: 0.15rem 0; min-height: 220px; }

// //         .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
// //         .form-group { margin-bottom: 1rem; }
// //         label.modal-label { display:block; margin-bottom:0.35rem; color: ${colors.text}; font-weight:600; font-size:0.95rem; }
// //         .modal-input:focus { outline:none; border-color: ${colors.primary}; box-shadow: 0 0 0 6px ${colors.primary}18; }

// //         .modal-submit-btn { width:100%; padding:0.95rem; background: linear-gradient(90deg, ${colors.primary}, ${colors.primary}); color:${colors.buttonText}; border:none; border-radius:0.6rem; font-weight:700; cursor:pointer; box-shadow: 0 8px 30px ${colors.primary}22; }
// //         .modal-submit-btn:disabled { opacity:0.75; cursor:not-allowed; }

// //         .radio-row { display:flex; gap:0.6rem; flex-wrap:wrap; align-items:center; }
// //         .radio-row label { display:flex; align-items:center; gap:0.45rem; color:${colors.text}; cursor:pointer; padding:0.18rem 0.2rem; border-radius:6px; }

// //         /* Responsive stacking */
// //         @media (max-width: 920px) {
// //           .registration-modal-container { grid-template-columns: 1fr; padding: 0.9rem; gap: 0.9rem; max-width: 760px; }
// //           .form-grid { grid-template-columns: 1fr; }
// //           .registration-left-panel { order: -1; min-height: auto; }
// //         }
// //         @media (max-width: 480px) {
// //           .registration-modal-container { max-width:100%; width:100%; height:100%; border-radius:0; padding:0.6rem; max-height:100vh; }
// //           .registration-left-panel { padding:0.75rem; border-radius:8px; }
// //           .modal-close-btn { top:0.45rem; right:0.45rem; }
// //         }
// //       `}</style>

// //       <div style={overlay} onClick={onClose}>
// //         <div
// //           className="registration-modal-container"
// //           onClick={(e) => e.stopPropagation()}
// //           role="dialog"
// //           aria-modal="true"
// //         >
// //           <button
// //             style={closeButtonStyle}
// //             onClick={onClose}
// //             className="modal-close-btn"
// //             aria-label="Close modal"
// //           >
// //             ×
// //           </button>

// //           <div className="registration-left-panel" aria-hidden={false}>
// //             <div
// //               style={{ display: "flex", gap: "0.6rem", alignItems: "center" }}
// //             >
// //               <span className="get-badge">G E T</span>
// //               <div style={{ display: "flex", flexDirection: "column" }}>
// //                 <strong style={{ fontSize: "0.98rem", color: colors.text }}>
// //                   Gurukul Entrance Test
// //                 </strong>
// //                 <small style={{ color: colors.textSecondary, marginTop: 2 }}>
// //                   APPLY FOR 2026
// //                 </small>
// //               </div>
// //             </div>

// //             <h2
// //               style={{
// //                 margin: 0,
// //                 color: colors.text,
// //                 fontSize: "1.45rem",
// //                 fontWeight: 800,
// //               }}
// //             >
// //               G E T 2026
// //             </h2>
// //             <p style={{ margin: 0, color: colors.textSecondary }}>
// //               For students entering <strong>11th / 12th</strong> — coaching for{" "}
// //               <strong>JEE • NEET</strong> (Science) and{" "}
// //               <strong>CA Foundation</strong> (Commerce).
// //             </p>

// //             <div style={{ marginTop: 8, color: colors.textSecondary }}>
// //               <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
// //                 <li>Golden opportunity for Science & Commerce aspirants</li>
// //                 <li>
// //                   Specialized JEE / NEET guidance and CA Foundation coaching
// //                 </li>
// //                 <li>
// //                   <strong>100% scholarship</strong> for qualified students
// //                 </li>
// //                 <li>Limited seats — priority for early registrants</li>
// //               </ul>
// //             </div>

// //             <div style={{ marginTop: 8 }}>
// //               <small style={{ color: colors.textSecondary }}>
// //                 Register now and our admissions team will contact you with next
// //                 steps and test details.
// //               </small>
// //             </div>
// //           </div>

// //           <div className="registration-form-panel">
// //             <form onSubmit={handleSubmit}>
// //               <div className="form-grid">
// //                 <div className="form-group">
// //                   <label className="modal-label">
// //                     Branch <span style={{ color: "#ef4444" }}>*</span>
// //                   </label>
// //                   <div
// //                     className="radio-row"
// //                     role="radiogroup"
// //                     aria-label="Branch choice"
// //                   >
// //                     <label>
// //                       <input
// //                         type="radio"
// //                         name="branchRadio"
// //                         value="Commerce"
// //                         checked={branchChoice === "Commerce"}
// //                         onChange={() => setBranchChoice("Commerce")}
// //                         required
// //                       />
// //                       <span>Commerce</span>
// //                     </label>
// //                     <label>
// //                       <input
// //                         type="radio"
// //                         name="branchRadio"
// //                         value="Science"
// //                         checked={branchChoice === "Science"}
// //                         onChange={() => setBranchChoice("Science")}
// //                         required
// //                       />
// //                       <span>Science</span>
// //                     </label>
// //                     <label>
// //                       <input
// //                         type="radio"
// //                         name="branchRadio"
// //                         value="Other"
// //                         checked={branchChoice === "Other"}
// //                         onChange={() => setBranchChoice("Other")}
// //                         required
// //                       />
// //                       <span>Other</span>
// //                     </label>
// //                   </div>

// //                   {branchChoice === "Other" && (
// //                     <input
// //                       type="text"
// //                       name="branchOther"
// //                       value={branchOther}
// //                       onChange={(e) => setBranchOther(e.target.value)}
// //                       style={{ ...inputBaseStyle, marginTop: "0.6rem" }}
// //                       className="modal-input"
// //                       required
// //                       placeholder="Enter branch"
// //                     />
// //                   )}
// //                 </div>

// //                 <div className="form-group">
// //                   <label className="modal-label" htmlFor="studentName">
// //                     Student Full Name{" "}
// //                     <span style={{ color: "#ef4444" }}>*</span>
// //                   </label>
// //                   <input
// //                     id="studentName"
// //                     name="studentName"
// //                     type="text"
// //                     value={formData.studentName}
// //                     onChange={handleChange}
// //                     style={inputBaseStyle}
// //                     className="modal-input"
// //                     required
// //                     placeholder="Enter student's full name"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="form-grid" style={{ marginTop: 8 }}>
// //                 <div className="form-group">
// //                   <label className="modal-label" htmlFor="schoolName">
// //                     School Name <span style={{ color: "#ef4444" }}>*</span>
// //                   </label>
// //                   <input
// //                     id="schoolName"
// //                     name="schoolName"
// //                     type="text"
// //                     value={formData.schoolName}
// //                     onChange={handleChange}
// //                     style={inputBaseStyle}
// //                     className="modal-input"
// //                     required
// //                     placeholder="Enter school name"
// //                   />
// //                 </div>

// //                 <div className="form-group">
// //                   <label className="modal-label" htmlFor="villageOrCity">
// //                     Village or City <span style={{ color: "#ef4444" }}>*</span>
// //                   </label>
// //                   <input
// //                     id="villageOrCity"
// //                     name="villageOrCity"
// //                     type="text"
// //                     value={formData.villageOrCity}
// //                     onChange={handleChange}
// //                     style={inputBaseStyle}
// //                     className="modal-input"
// //                     required
// //                     placeholder="Enter village or city"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="form-group" style={{ marginTop: 8 }}>
// //                 <label className="modal-label" htmlFor="address">
// //                   Address <span style={{ color: "#ef4444" }}>*</span>
// //                 </label>
// //                 <textarea
// //                   id="address"
// //                   name="address"
// //                   value={formData.address}
// //                   onChange={handleChange}
// //                   style={{
// //                     ...inputBaseStyle,
// //                     minHeight: "96px",
// //                     resize: "vertical",
// //                   }}
// //                   className="modal-input"
// //                   required
// //                   placeholder="Enter full address"
// //                 />
// //               </div>

// //               <div className="form-grid" style={{ marginTop: 8 }}>
// //                 <div className="form-group">
// //                   <label className="modal-label" htmlFor="mobileNumber">
// //                     Mobile Number <span style={{ color: "#ef4444" }}>*</span>
// //                   </label>
// //                   <input
// //                     id="mobileNumber"
// //                     name="mobileNumber"
// //                     type="tel"
// //                     value={formData.mobileNumber}
// //                     onChange={handleChange}
// //                     style={inputBaseStyle}
// //                     className="modal-input"
// //                     required
// //                     placeholder="Enter mobile number"
// //                     pattern="[0-9]{10}"
// //                     maxLength="10"
// //                   />
// //                 </div>

// //                 <div className="form-group">
// //                   <label className="modal-label" htmlFor="emailId">
// //                     Email (optional)
// //                   </label>
// //                   <input
// //                     id="emailId"
// //                     name="emailId"
// //                     type="email"
// //                     value={formData.emailId}
// //                     onChange={handleChange}
// //                     style={inputBaseStyle}
// //                     className="modal-input"
// //                     placeholder="Enter email (optional)"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="form-grid" style={{ marginTop: 8 }}>
// //                 <div className="form-group">
// //                   <label className="modal-label" htmlFor="lastExamPercentage">
// //                     Last Exam Percentage{" "}
// //                     <span style={{ color: "#ef4444" }}>*</span>
// //                   </label>
// //                   <input
// //                     id="lastExamPercentage"
// //                     name="lastExamPercentage"
// //                     type="number"
// //                     inputMode="decimal"
// //                     min="0"
// //                     max="100"
// //                     step="0.01"
// //                     value={formData.lastExamPercentage}
// //                     onChange={handleChange}
// //                     style={inputBaseStyle}
// //                     className="modal-input"
// //                     required
// //                     placeholder="e.g., 85.5"
// //                   />
// //                 </div>

// //                 <div className="form-group">
// //                   <label className="modal-label" htmlFor="interestedFor">
// //                     Interested For <span style={{ color: "#ef4444" }}>*</span>
// //                   </label>
// //                   <select
// //                     id="interestedFor"
// //                     name="interestedFor"
// //                     value={formData.interestedFor}
// //                     onChange={handleChange}
// //                     style={{ ...inputBaseStyle, appearance: "none" }}
// //                     className="modal-input"
// //                     required
// //                   >
// //                     <option value="">Select</option>
// //                     {getInterestedOptions().map((opt) => (
// //                       <option key={opt} value={opt}>
// //                         {opt}
// //                       </option>
// //                     ))}
// //                   </select>
// //                 </div>
// //               </div>

// //               <div style={{ marginTop: "0.75rem" }}>
// //                 <button
// //                   type="submit"
// //                   className="modal-submit-btn"
// //                   disabled={isSubmitting}
// //                 >
// //                   {isSubmitting ? "Submitting..." : "Submit Registration"}
// //                 </button>
// //               </div>

// //               <div style={{ height: 18 }} aria-hidden="true" />
// //             </form>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default RegistrationModal;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useTheme } from "../context/ThemeContext";

// const RegistrationModal = ({ isOpen, onClose }) => {
//   const { colors } = useTheme();

//   const [formData, setFormData] = useState({
//     branch: "",
//     studentName: "",
//     schoolName: "",
//     villageOrCity: "",
//     address: "",
//     mobileNumber: "",
//     lastExamPercentage: "",
//     emailId: "",
//     // store as array for multi-select UI, convert to string on submit
//     interestedFor: [],
//   });

//   const [branchChoice, setBranchChoice] = useState("");
//   const [branchOther, setBranchOther] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     if (!isOpen) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [isOpen, onClose]);

//   const handleChange = (e) =>
//     setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

//   // handle multi-select change
//   const handleMultiSelect = (e) => {
//     const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
//     setFormData((s) => ({ ...s, interestedFor: selected }));
//   };

//   // update branch field and reset interestedFor when branch changes
//   useEffect(() => {
//     const finalBranch = branchChoice === "Other" ? branchOther : branchChoice;
//     setFormData((s) => ({ ...s, branch: finalBranch }));
//     setFormData((s) => ({ ...s, interestedFor: [] }));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [branchChoice, branchOther]);

//   const validatePercentage = (val) => {
//     if (val === "") return false;
//     const n = Number(val);
//     return !Number.isNaN(n) && n >= 0 && n <= 100;
//   };

//   const getInterestedOptions = () => {
//     if (branchChoice === "Science") return ["CET", "JEE", "NEET"];
//     if (branchChoice === "Commerce") return ["CA Foundation"];
//     return ["CET", "JEE", "NEET", "CA Foundation"];
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // client-side validation (email optional)
//     if (!branchChoice || (branchChoice === "Other" && !branchOther.trim())) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please select/enter Branch.",
//       });
//     }
//     if (!formData.studentName.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter student's full name.",
//       });
//     }
//     if (!formData.schoolName.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter school name.",
//       });
//     }
//     if (!formData.villageOrCity.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter village or city.",
//       });
//     }
//     if (!formData.address.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter address.",
//       });
//     }
//     if (!/^\d{10}$/.test(formData.mobileNumber)) {
//       return Swal.fire({
//         icon: "error",
//         title: "Invalid mobile",
//         text: "Please enter a valid 10-digit mobile number.",
//       });
//     }
//     if (!validatePercentage(formData.lastExamPercentage)) {
//       return Swal.fire({
//         icon: "error",
//         title: "Invalid percentage",
//         text: "Please enter last exam percentage between 0 and 100.",
//       });
//     }
//     if (!formData.interestedFor || formData.interestedFor.length === 0) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please select at least one option for 'Interested For'.",
//       });
//     }

//     setIsSubmitting(true);

//     try {
//       const finalBranch =
//         branchChoice === "Other" ? (branchOther || "").trim() : branchChoice;

//       // convert interestedFor array to single comma-separated string for backend
//       const interestedForString = formData.interestedFor.join(",");

//       const payload = {
//         ...formData,
//         branch: finalBranch,
//         lastExamPercentage: Number(formData.lastExamPercentage),
//         interestedFor: interestedForString,
//       };

//       const response = await axios.post(
//         "https://gurukulschools.org/api/api/public/student-registration",
//         payload
//       );

//       if (response.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Registration Successful!",
//           text: "Your registration has been submitted successfully. We will contact you soon.",
//           confirmButtonColor: "#0ea5e9",
//           confirmButtonText: "OK",
//         });

//         // Reset form
//         setFormData({
//           branch: "",
//           studentName: "",
//           schoolName: "",
//           villageOrCity: "",
//           address: "",
//           mobileNumber: "",
//           lastExamPercentage: "",
//           emailId: "",
//           interestedFor: [],
//         });
//         setBranchChoice("");
//         setBranchOther("");
//         onClose();
//       } else {
//         throw new Error("Unexpected response");
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Registration Failed",
//         text:
//           error.response?.data?.message ||
//           error.message ||
//           "Something went wrong. Please try again.",
//         confirmButtonColor: "#ef4444",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   const overlay = {
//     position: "fixed",
//     inset: 0,
//     background:
//       "linear-gradient(180deg, rgba(2,6,23,0.5) 0%, rgba(2,6,23,0.6) 100%)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 2000,
//     padding: "1rem",
//     WebkitOverflowScrolling: "touch",
//   };

//   const closeButtonStyle = {
//     position: "absolute",
//     top: "0.6rem",
//     right: "0.6rem",
//     background: "none",
//     border: "none",
//     fontSize: "1.4rem",
//     cursor: "pointer",
//     color: colors.textSecondary,
//     width: "36px",
//     height: "36px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     borderRadius: "50%",
//   };

//   const inputBaseStyle = {
//     width: "100%",
//     padding: "0.75rem",
//     border: `1px solid ${colors.border}`,
//     borderRadius: "0.5rem",
//     fontSize: "1rem",
//     fontFamily: "inherit",
//     transition: "border-color 0.15s ease",
//     boxSizing: "border-box",
//     background: colors.backgroundAlt,
//     color: colors.text,
//   };

//   return (
//     <>
//       <style>{`
//         @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
//         @keyframes slideUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }

//         /* Entire modal container scrolls when content overflows */
//         .registration-modal-container {
//           width: 100%;
//           max-width: 1000px;
//           max-height: calc(100vh - 48px);
//           overflow: auto; /* whole panel scrolls */
//           -webkit-overflow-scrolling: touch;
//           border-radius: 14px;
//           box-shadow: 0 20px 60px rgba(2,6,23,0.45);
//           display: grid;
//           grid-template-columns: 420px 1fr; /* left column fixed-ish, right flexible */
//           gap: 1.25rem;
//           padding: 1.15rem;
//           background: ${colors.card};
//           position: relative;
//           animation: slideUp 0.22s ease-in-out;
//         }

//         .registration-modal-container::-webkit-scrollbar { width: 10px; height: 10px; }
//         .registration-modal-container::-webkit-scrollbar-track { background: transparent; }
//         .registration-modal-container::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.08); border-radius: 12px; border: 2px solid transparent; background-clip: padding-box; }
//         .registration-modal-container { scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.08) transparent; }

//         .registration-left-panel {
//           padding: 1rem;
//           border-radius: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 0.9rem;
//           justify-content: center;
//           align-items: flex-start;
//           min-height: 220px;
//           background: linear-gradient(135deg, ${colors.primary}22, ${colors.primary}08);
//         }
//         .get-badge { display:inline-block; font-weight:800; padding:0.32rem 0.55rem; border-radius:999px; font-size:0.86rem; background:${colors.backgroundAlt}; color:${colors.text}; border:1px solid ${colors.border}; }

//         .registration-form-panel { padding: 0.15rem 0; min-height: 220px; }

//         .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
//         .form-group { margin-bottom: 1rem; }
//         label.modal-label { display:block; margin-bottom:0.35rem; color: ${colors.text}; font-weight:600; font-size:0.95rem; }
//         .modal-input:focus { outline:none; border-color: ${colors.primary}; box-shadow: 0 0 0 6px ${colors.primary}18; }

//         .modal-submit-btn { width:100%; padding:0.95rem; background: linear-gradient(90deg, ${colors.primary}, ${colors.primary}); color:${colors.buttonText}; border:none; border-radius:0.6rem; font-weight:700; cursor:pointer; box-shadow: 0 8px 30px ${colors.primary}22; }
//         .modal-submit-btn:disabled { opacity:0.75; cursor:not-allowed; }

//         .radio-row { display:flex; gap:0.6rem; flex-wrap:wrap; align-items:center; }
//         .radio-row label { display:flex; align-items:center; gap:0.45rem; color:${colors.text}; cursor:pointer; padding:0.18rem 0.2rem; border-radius:6px; }

//         /* multi-select styling */
//         select[multiple] {
//           min-height: 84px;
//         }

//         /* Responsive stacking */
//         @media (max-width: 920px) {
//           .registration-modal-container { grid-template-columns: 1fr; padding: 0.9rem; gap: 0.9rem; max-width: 760px; }
//           .form-grid { grid-template-columns: 1fr; }
//           .registration-left-panel { order: -1; min-height: auto; }
//         }
//         @media (max-width: 480px) {
//           .registration-modal-container { max-width:100%; width:100%; height:100%; border-radius:0; padding:0.6rem; max-height:100vh; }
//           .registration-left-panel { padding:0.75rem; border-radius:8px; }
//           .modal-close-btn { top:0.45rem; right:0.45rem; }
//         }
//       `}</style>

//       <div style={overlay} onClick={onClose}>
//         <div
//           className="registration-modal-container"
//           onClick={(e) => e.stopPropagation()}
//           role="dialog"
//           aria-modal="true"
//         >
//           <button
//             style={closeButtonStyle}
//             onClick={onClose}
//             className="modal-close-btn"
//             aria-label="Close modal"
//           >
//             ×
//           </button>

//           <div className="registration-left-panel" aria-hidden={false}>
//             <div
//               style={{ display: "flex", gap: "0.6rem", alignItems: "center" }}
//             >
//               <span className="get-badge">G E T</span>
//               <div style={{ display: "flex", flexDirection: "column" }}>
//                 <strong style={{ fontSize: "0.98rem", color: colors.text }}>
//                   Gurukul Entrance Test
//                 </strong>
//                 <small style={{ color: colors.textSecondary, marginTop: 2 }}>
//                   APPLY FOR 2026
//                 </small>
//               </div>
//             </div>

//             <h2
//               style={{
//                 margin: 0,
//                 color: colors.text,
//                 fontSize: "1.45rem",
//                 fontWeight: 800,
//               }}
//             >
//               G E T 2026
//             </h2>
//             <p style={{ margin: 0, color: colors.textSecondary }}>
//               For students entering <strong>11th / 12th</strong> — coaching for{" "}
//               <strong>JEE • NEET</strong> (Science) and{" "}
//               <strong>CA Foundation</strong> (Commerce).
//             </p>

//             <div style={{ marginTop: 8, color: colors.textSecondary }}>
//               <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
//                 <li>Golden opportunity for Science & Commerce aspirants</li>
//                 <li>
//                   Specialized JEE / NEET guidance and CA Foundation coaching
//                 </li>
//                 <li>
//                   <strong>100% scholarship</strong> for qualified students
//                 </li>
//                 <li>Limited seats — priority for early registrants</li>
//               </ul>
//             </div>

//             <div style={{ marginTop: 8 }}>
//               <small style={{ color: colors.textSecondary }}>
//                 Register now and our admissions team will contact you with next
//                 steps and test details.
//               </small>
//             </div>
//           </div>

//           <div className="registration-form-panel">
//             <form onSubmit={handleSubmit}>
//               <div className="form-grid">
//                 <div className="form-group">
//                   <label className="modal-label">
//                     Branch <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <div
//                     className="radio-row"
//                     role="radiogroup"
//                     aria-label="Branch choice"
//                   >
//                     <label>
//                       <input
//                         type="radio"
//                         name="branchRadio"
//                         value="Commerce"
//                         checked={branchChoice === "Commerce"}
//                         onChange={() => setBranchChoice("Commerce")}
//                         required
//                       />
//                       <span>Commerce</span>
//                     </label>
//                     <label>
//                       <input
//                         type="radio"
//                         name="branchRadio"
//                         value="Science"
//                         checked={branchChoice === "Science"}
//                         onChange={() => setBranchChoice("Science")}
//                         required
//                       />
//                       <span>Science</span>
//                     </label>
//                     <label>
//                       <input
//                         type="radio"
//                         name="branchRadio"
//                         value="Other"
//                         checked={branchChoice === "Other"}
//                         onChange={() => setBranchChoice("Other")}
//                         required
//                       />
//                       <span>Other</span>
//                     </label>
//                   </div>

//                   {branchChoice === "Other" && (
//                     <input
//                       type="text"
//                       name="branchOther"
//                       value={branchOther}
//                       onChange={(e) => setBranchOther(e.target.value)}
//                       style={{ ...inputBaseStyle, marginTop: "0.6rem" }}
//                       className="modal-input"
//                       required
//                       placeholder="Enter branch"
//                     />
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="studentName">
//                     Student Full Name{" "}
//                     <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="studentName"
//                     name="studentName"
//                     type="text"
//                     value={formData.studentName}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter student's full name"
//                   />
//                 </div>
//               </div>

//               <div className="form-grid" style={{ marginTop: 8 }}>
//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="schoolName">
//                     School Name <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="schoolName"
//                     name="schoolName"
//                     type="text"
//                     value={formData.schoolName}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter school name"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="villageOrCity">
//                     Village or City <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="villageOrCity"
//                     name="villageOrCity"
//                     type="text"
//                     value={formData.villageOrCity}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter village or city"
//                   />
//                 </div>
//               </div>

//               <div className="form-group" style={{ marginTop: 8 }}>
//                 <label className="modal-label" htmlFor="address">
//                   Address <span style={{ color: "#ef4444" }}>*</span>
//                 </label>
//                 <textarea
//                   id="address"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   style={{
//                     ...inputBaseStyle,
//                     minHeight: "96px",
//                     resize: "vertical",
//                   }}
//                   className="modal-input"
//                   required
//                   placeholder="Enter full address"
//                 />
//               </div>

//               <div className="form-grid" style={{ marginTop: 8 }}>
//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="mobileNumber">
//                     Mobile Number <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="mobileNumber"
//                     name="mobileNumber"
//                     type="tel"
//                     value={formData.mobileNumber}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter mobile number"
//                     pattern="[0-9]{10}"
//                     maxLength="10"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="emailId">
//                     Email (optional)
//                   </label>
//                   <input
//                     id="emailId"
//                     name="emailId"
//                     type="email"
//                     value={formData.emailId}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     placeholder="Enter email (optional)"
//                   />
//                 </div>
//               </div>

//               <div className="form-grid" style={{ marginTop: 8 }}>
//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="lastExamPercentage">
//                     Last Exam Percentage{" "}
//                     <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="lastExamPercentage"
//                     name="lastExamPercentage"
//                     type="number"
//                     inputMode="decimal"
//                     min="0"
//                     max="100"
//                     step="0.01"
//                     value={formData.lastExamPercentage}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="e.g., 85.5"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="interestedFor">
//                     Interested For <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <select
//                     id="interestedFor"
//                     name="interestedFor"
//                     multiple
//                     value={formData.interestedFor}
//                     onChange={handleMultiSelect}
//                     style={{ ...inputBaseStyle, appearance: "auto" }}
//                     className="modal-input"
//                   >
//                     {getInterestedOptions().map((opt) => (
//                       <option key={opt} value={opt}>
//                         {opt}
//                       </option>
//                     ))}
//                   </select>
//                   <small
//                     style={{
//                       color: colors.textSecondary,
//                       display: "block",
//                       marginTop: 6,
//                     }}
//                   >
//                     Hold Ctrl (or Cmd) to select multiple on desktop; tap
//                     multiple on mobile.
//                   </small>
//                 </div>
//               </div>

//               <div style={{ marginTop: "0.75rem" }}>
//                 <button
//                   type="submit"
//                   className="modal-submit-btn"
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? "Submitting..." : "Submit Registration"}
//                 </button>
//               </div>

//               <div style={{ height: 18 }} aria-hidden="true" />
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default RegistrationModal;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useTheme } from "../context/ThemeContext";
// import Img from "../assessts/Add.jpeg";

// const RegistrationModal = ({ isOpen, onClose }) => {
//   const { colors } = useTheme();

//   const [formData, setFormData] = useState({
//     branch: "",
//     studentName: "",
//     schoolName: "",
//     villageOrCity: "",
//     address: "",
//     mobileNumber: "",
//     lastExamPercentage: "",
//     emailId: "",
//     // ui array for checkboxes -> convert to string on submit
//     interestedFor: [],
//   });

//   const [branchChoice, setBranchChoice] = useState(""); // "Science" | "Commerce"
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     if (!isOpen) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [isOpen, onClose]);

//   // helper to update simple fields
//   const handleChange = (e) =>
//     setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

//   // when branch changes: set branch and reset interestedFor
//   const handleBranchChange = (value) => {
//     setBranchChoice(value);
//     setFormData((s) => ({ ...s, branch: value, interestedFor: [] }));
//   };

//   // checkbox toggle for interestedFor
//   const handleInterestToggle = (value) => {
//     setFormData((s) => {
//       const arr = new Set(s.interestedFor || []);
//       if (arr.has(value)) arr.delete(value);
//       else arr.add(value);
//       return { ...s, interestedFor: Array.from(arr) };
//     });
//   };

//   const validatePercentage = (val) => {
//     if (val === "") return false;
//     const n = Number(val);
//     return !Number.isNaN(n) && n >= 0 && n <= 100;
//   };

//   const getInterestedOptions = () => {
//     if (branchChoice === "Science") return ["CET", "JEE", "NEET"];
//     if (branchChoice === "Commerce") return ["CA Foundation"];
//     return []; // none until branch chosen
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // client-side validation (email optional)
//     if (!branchChoice) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please select Branch (Science or Commerce).",
//       });
//     }
//     if (!formData.studentName.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter student's full name.",
//       });
//     }
//     if (!formData.schoolName.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter school name.",
//       });
//     }
//     if (!formData.villageOrCity.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter village or city.",
//       });
//     }
//     if (!formData.address.trim()) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please enter address.",
//       });
//     }
//     if (!/^\d{10}$/.test(formData.mobileNumber)) {
//       return Swal.fire({
//         icon: "error",
//         title: "Invalid mobile",
//         text: "Please enter a valid 10-digit mobile number.",
//       });
//     }
//     if (!validatePercentage(formData.lastExamPercentage)) {
//       return Swal.fire({
//         icon: "error",
//         title: "Invalid percentage",
//         text: "Please enter last exam percentage between 0 and 100.",
//       });
//     }
//     if (!formData.interestedFor || formData.interestedFor.length === 0) {
//       return Swal.fire({
//         icon: "error",
//         title: "Missing field",
//         text: "Please choose at least one option under 'Interested For'.",
//       });
//     }

//     setIsSubmitting(true);

//     try {
//       const payload = {
//         ...formData,
//         branch: branchChoice,
//         lastExamPercentage: Number(formData.lastExamPercentage),
//         // send interestedFor as single comma-separated string
//         interestedFor: formData.interestedFor.join(","),
//       };

//       const response = await axios.post(
//         "https://gurukulschools.org/api/api/public/student-registration",
//         payload
//       );

//       if (response.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Registration Successful!",
//           text: "Your registration has been submitted successfully. We will contact you soon.",
//           confirmButtonColor: "#0ea5e9",
//           confirmButtonText: "OK",
//         });

//         // Reset form
//         setFormData({
//           branch: "",
//           studentName: "",
//           schoolName: "",
//           villageOrCity: "",
//           address: "",
//           mobileNumber: "",
//           lastExamPercentage: "",
//           emailId: "",
//           interestedFor: [],
//         });
//         setBranchChoice("");
//         onClose();
//       } else {
//         throw new Error("Unexpected response");
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Registration Failed",
//         text:
//           error.response?.data?.message ||
//           error.message ||
//           "Something went wrong. Please try again.",
//         confirmButtonColor: "#ef4444",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   const overlay = {
//     position: "fixed",
//     inset: 0,
//     background:
//       "linear-gradient(180deg, rgba(2,6,23,0.5) 0%, rgba(2,6,23,0.6) 100%)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 2000,
//     padding: "1rem",
//     WebkitOverflowScrolling: "touch",
//   };

//   const closeButtonStyle = {
//     position: "absolute",
//     top: "0.6rem",
//     right: "0.6rem",
//     background: "none",
//     border: "none",
//     fontSize: "1.4rem",
//     cursor: "pointer",
//     color: colors.textSecondary,
//     width: "36px",
//     height: "36px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     borderRadius: "50%",
//   };

//   const inputBaseStyle = {
//     width: "100%",
//     padding: "0.75rem",
//     border: `1px solid ${colors.border}`,
//     borderRadius: "0.5rem",
//     fontSize: "1rem",
//     fontFamily: "inherit",
//     transition: "border-color 0.15s ease",
//     boxSizing: "border-box",
//     background: colors.backgroundAlt,
//     color: colors.text,
//   };

//   return (
//     <>
//       <style>{`
//         @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
//         @keyframes slideUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }

//         /* Entire modal container scrolls when content overflows */
//         .registration-modal-container {
//           width: 100%;
//           max-width: 1000px;
//           max-height: calc(100vh - 48px);
//           overflow: auto; /* whole panel scrolls */
//           -webkit-overflow-scrolling: touch;
//           border-radius: 14px;
//           box-shadow: 0 20px 60px rgba(2,6,23,0.45);
//           display: grid;
//           grid-template-columns: 420px 1fr; /* left column fixed-ish, right flexible */
//           gap: 1.25rem;
//           padding: 1.15rem;
//           background: ${colors.card};
//           position: relative;
//           animation: slideUp 0.22s ease-in-out;
//         }

//         .registration-modal-container::-webkit-scrollbar { width: 10px; height: 10px; }
//         .registration-modal-container::-webkit-scrollbar-track { background: transparent; }
//         .registration-modal-container::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.08); border-radius: 12px; border: 2px solid transparent; background-clip: padding-box; }
//         .registration-modal-container { scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.08) transparent; }

//         .registration-left-panel {
//           padding: 1rem;
//           border-radius: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 0.9rem;
//           justify-content: center;
//           align-items: flex-start;
//           min-height: 220px;
//           background: linear-gradient(135deg, ${colors.primary}22, ${colors.primary}08);
//         }
//         .get-badge { display:inline-block; font-weight:800; padding:0.32rem 0.55rem; border-radius:999px; font-size:0.86rem; background:${colors.backgroundAlt}; color:${colors.text}; border:1px solid ${colors.border}; }

//         .registration-form-panel { padding: 0.15rem 0; min-height: 220px; }

//         .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
//         .form-group { margin-bottom: 1rem; }
//         label.modal-label { display:block; margin-bottom:0.35rem; color: ${colors.text}; font-weight:600; font-size:0.95rem; }
//         .modal-input:focus { outline:none; border-color: ${colors.primary}; box-shadow: 0 0 0 6px ${colors.primary}18; }

//         .modal-submit-btn { width:100%; padding:0.95rem; background: linear-gradient(90deg, ${colors.primary}, ${colors.primary}); color:${colors.buttonText}; border:none; border-radius:0.6rem; font-weight:700; cursor:pointer; box-shadow: 0 8px 30px ${colors.primary}22; }
//         .modal-submit-btn:disabled { opacity:0.75; cursor:not-allowed; }

//         .radio-row { display:flex; gap:0.6rem; flex-wrap:wrap; align-items:center; }
//         .radio-row label { display:flex; align-items:center; gap:0.45rem; color:${colors.text}; cursor:pointer; padding:0.18rem 0.2rem; border-radius:6px; }

//         /* interested checkbox list */
//         .interest-list { display:flex; flex-direction:column; gap:8px; margin-top:6px; }
//         .interest-item { display:flex; align-items:center; gap:0.6rem; cursor:pointer; color: ${colors.text}; }
//         .interest-item input { width: 18px; height: 18px; }

//         /* Responsive stacking */
//         @media (max-width: 920px) {
//           .registration-modal-container { grid-template-columns: 1fr; padding: 0.9rem; gap: 0.9rem; max-width: 760px; }
//           .form-grid { grid-template-columns: 1fr; }
//           .registration-left-panel { order: -1; min-height: auto; }
//         }
//         @media (max-width: 480px) {
//           .registration-modal-container { max-width:100%; width:100%; height:100%; border-radius:0; padding:0.6rem; max-height:100vh; }
//           .registration-left-panel { padding:0.75rem; border-radius:8px; }
//           .modal-close-btn { top:0.45rem; right:0.45rem; }
//         }
//       `}</style>

//       <div style={overlay} onClick={onClose}>
//         <div
//           className="registration-modal-container"
//           onClick={(e) => e.stopPropagation()}
//           role="dialog"
//           aria-modal="true"
//         >
//           <button
//             style={closeButtonStyle}
//             onClick={onClose}
//             className="modal-close-btn"
//             aria-label="Close modal"
//           >
//             ×
//           </button>

//           <div className="registration-left-panel" aria-hidden={false}>
//             <div
//               style={{ display: "flex", gap: "0.6rem", alignItems: "center" }}
//             >
//               <span className="get-badge">G E T</span>
//               <div style={{ display: "flex", flexDirection: "column" }}>
//                 <strong style={{ fontSize: "0.98rem", color: colors.text }}>
//                   Gurukul Entrance Test
//                 </strong>
//                 <small style={{ color: colors.textSecondary, marginTop: 2 }}>
//                   APPLY FOR 2026
//                 </small>
//               </div>
//             </div>

//             <h2
//               style={{
//                 margin: 0,
//                 color: colors.text,
//                 fontSize: "1.45rem",
//                 fontWeight: 800,
//               }}
//             >
//               G E T 2026
//             </h2>
//             <p style={{ margin: 0, color: colors.textSecondary }}>
//               For students entering <strong>11th / 12th</strong> — coaching for{" "}
//               <strong>JEE • NEET</strong> (Science) and{" "}
//               <strong>CA Foundation</strong> (Commerce).
//             </p>

//             <div style={{ marginTop: 8, color: colors.textSecondary }}>
//               <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
//                 <li>Golden opportunity for Science & Commerce aspirants</li>
//                 <li>
//                   Specialized JEE / NEET guidance and CA Foundation coaching
//                 </li>
//                 <li>
//                   <strong>100% scholarship</strong> for qualified students
//                 </li>
//                 <li>Limited seats — priority for early registrants</li>
//               </ul>
//             </div>

//             <div style={{ marginTop: 8 }}>
//               <small style={{ color: colors.textSecondary }}>
//                 Register now and our admissions team will contact you with next
//                 steps and test details.
//               </small>
//             </div>
//           </div>

//           <div className="registration-form-panel">
//             <form onSubmit={handleSubmit}>
//               <div className="form-grid">
//                 <div className="form-group">
//                   <label className="modal-label">
//                     Branch <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <div
//                     className="radio-row"
//                     role="radiogroup"
//                     aria-label="Branch choice"
//                   >
//                     <label>
//                       <input
//                         type="radio"
//                         name="branchRadio"
//                         value="Commerce"
//                         checked={branchChoice === "Commerce"}
//                         onChange={() => handleBranchChange("Commerce")}
//                         required
//                       />
//                       <span>Commerce</span>
//                     </label>
//                     <label>
//                       <input
//                         type="radio"
//                         name="branchRadio"
//                         value="Science"
//                         checked={branchChoice === "Science"}
//                         onChange={() => handleBranchChange("Science")}
//                         required
//                       />
//                       <span>Science</span>
//                     </label>
//                   </div>
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="studentName">
//                     Student Full Name{" "}
//                     <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="studentName"
//                     name="studentName"
//                     type="text"
//                     value={formData.studentName}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter student's full name"
//                   />
//                 </div>
//               </div>

//               <div className="form-grid" style={{ marginTop: 8 }}>
//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="schoolName">
//                     School Name <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="schoolName"
//                     name="schoolName"
//                     type="text"
//                     value={formData.schoolName}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter school name"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="villageOrCity">
//                     Village or City <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="villageOrCity"
//                     name="villageOrCity"
//                     type="text"
//                     value={formData.villageOrCity}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter village or city"
//                   />
//                 </div>
//               </div>

//               <div className="form-group" style={{ marginTop: 8 }}>
//                 <label className="modal-label" htmlFor="address">
//                   Address <span style={{ color: "#ef4444" }}>*</span>
//                 </label>
//                 <textarea
//                   id="address"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   style={{
//                     ...inputBaseStyle,
//                     minHeight: "96px",
//                     resize: "vertical",
//                   }}
//                   className="modal-input"
//                   required
//                   placeholder="Enter full address"
//                 />
//               </div>

//               <div className="form-grid" style={{ marginTop: 8 }}>
//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="mobileNumber">
//                     Mobile Number <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="mobileNumber"
//                     name="mobileNumber"
//                     type="tel"
//                     value={formData.mobileNumber}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="Enter mobile number"
//                     pattern="[0-9]{10}"
//                     maxLength="10"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="emailId">
//                     Email (optional)
//                   </label>
//                   <input
//                     id="emailId"
//                     name="emailId"
//                     type="email"
//                     value={formData.emailId}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     placeholder="Enter email (optional)"
//                   />
//                 </div>
//               </div>

//               <div className="form-grid" style={{ marginTop: 8 }}>
//                 <div className="form-group">
//                   <label className="modal-label" htmlFor="lastExamPercentage">
//                     Last Exam Percentage{" "}
//                     <span style={{ color: "#ef4444" }}>*</span>
//                   </label>
//                   <input
//                     id="lastExamPercentage"
//                     name="lastExamPercentage"
//                     type="number"
//                     inputMode="decimal"
//                     min="0"
//                     max="100"
//                     step="0.01"
//                     value={formData.lastExamPercentage}
//                     onChange={handleChange}
//                     style={inputBaseStyle}
//                     className="modal-input"
//                     required
//                     placeholder="e.g., 85.5"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label className="modal-label">
//                     Interested For <span style={{ color: "#ef4444" }}>*</span>
//                   </label>

//                   {/* If branch not chosen, show helper */}
//                   {branchChoice ? (
//                     <div
//                       className="interest-list"
//                       role="group"
//                       aria-label="Interested for options"
//                     >
//                       {getInterestedOptions().map((opt) => (
//                         <label key={opt} className="interest-item">
//                           <input
//                             type="checkbox"
//                             name="interestedForCheckbox"
//                             value={opt}
//                             checked={(formData.interestedFor || []).includes(
//                               opt
//                             )}
//                             onChange={() => handleInterestToggle(opt)}
//                           />
//                           <span>{opt}</span>
//                         </label>
//                       ))}
//                     </div>
//                   ) : (
//                     <div
//                       style={{
//                         color: colors.textSecondary,
//                         fontSize: "0.95rem",
//                       }}
//                     >
//                       Please select a Branch to choose relevant options.
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div style={{ marginTop: "0.75rem" }}>
//                 <button
//                   type="submit"
//                   className="modal-submit-btn"
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? "Submitting..." : "Submit Registration"}
//                 </button>
//               </div>

//               <div style={{ height: 18 }} aria-hidden="true" />
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default RegistrationModal;



import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useTheme } from "../context/ThemeContext";
import Img from "../assessts/Add.jpeg";

const RegistrationModal = ({ isOpen, onClose }) => {
  const { colors } = useTheme();

  const [formData, setFormData] = useState({
    branch: "",
    studentName: "",
    schoolName: "",
    villageOrCity: "",
    address: "",
    mobileNumber: "",
    lastExamPercentage: "",
    emailId: "",
    interestedFor: [],
  });

  const [branchChoice, setBranchChoice] = useState(""); // "Science" | "Commerce" | "Other"
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  const handleChange = (e) =>
    setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

  const handleBranchChange = (value) => {
    setBranchChoice(value);
    setFormData((s) => ({ ...s, branch: value, interestedFor: [] }));
  };

  const handleInterestToggle = (value) => {
    setFormData((s) => {
      const arr = new Set(s.interestedFor || []);
      if (arr.has(value)) arr.delete(value);
      else arr.add(value);
      return { ...s, interestedFor: Array.from(arr) };
    });
  };

  const validatePercentage = (val) => {
    if (val === "") return false;
    const n = Number(val);
    return !Number.isNaN(n) && n >= 0 && n <= 100;
  };

  const getInterestedOptions = () => {
    if (branchChoice === "Science") return ["CET", "JEE", "NEET"];
    if (branchChoice === "Commerce") return ["CA Foundation"];
    return []; // No options for "Other" or until a branch is chosen
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!branchChoice) {
      return Swal.fire({
        icon: "error",
        title: "Missing field",
        text: "Please select a Branch.",
      });
    }
    if (!formData.studentName.trim()) {
      return Swal.fire({
        icon: "error",
        title: "Missing field",
        text: "Please enter student's full name.",
      });
    }
    if (!formData.schoolName.trim()) {
      return Swal.fire({
        icon: "error",
        title: "Missing field",
        text: "Please enter school name.",
      });
    }
    if (!formData.villageOrCity.trim()) {
      return Swal.fire({
        icon: "error",
        title: "Missing field",
        text: "Please enter village or city.",
      });
    }
    if (!formData.address.trim()) {
      return Swal.fire({
        icon: "error",
        title: "Missing field",
        text: "Please enter address.",
      });
    }
    if (!/^\d{10}$/.test(formData.mobileNumber)) {
      return Swal.fire({
        icon: "error",
        title: "Invalid mobile",
        text: "Please enter a valid 10-digit mobile number.",
      });
    }
    if (!validatePercentage(formData.lastExamPercentage)) {
      return Swal.fire({
        icon: "error",
        title: "Invalid percentage",
        text: "Please enter last exam percentage between 0 and 100.",
      });
    }
    if (
      getInterestedOptions().length > 0 &&
      (!formData.interestedFor || formData.interestedFor.length === 0)
    ) {
      return Swal.fire({
        icon: "error",
        title: "Missing field",
        text: "Please choose at least one option under 'Interested For'.",
      });
    }

    setIsSubmitting(true);

    try {
      const payload = {
        ...formData,
        branch: branchChoice,
        lastExamPercentage: Number(formData.lastExamPercentage),
        interestedFor: formData.interestedFor.join(","),
      };

      const response = await axios.post(
        "https://gurukulschools.org/api/api/public/student-registration",
        payload
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Registration Successful!",
          text: "Your registration has been submitted successfully. We will contact you soon.",
          confirmButtonColor: "#0ea5e9",
          confirmButtonText: "OK",
        });

        setFormData({
          branch: "",
          studentName: "",
          schoolName: "",
          villageOrCity: "",
          address: "",
          mobileNumber: "",
          lastExamPercentage: "",
          emailId: "",
          interestedFor: [],
        });
        setBranchChoice("");
        onClose();
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong. Please try again.",
        confirmButtonColor: "#ef4444",
        confirmButtonText: "OK",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  const overlay = {
    position: "fixed",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(2,6,23,0.5) 0%, rgba(2,6,23,0.6) 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    padding: "1rem",
    WebkitOverflowScrolling: "touch",
  };

  const closeButtonStyle = {
    position: "absolute",
    top: "0.6rem",
    right: "0.6rem",
    background: "none",
    border: "none",
    fontSize: "1.4rem",
    cursor: "pointer",
    color: colors.textSecondary,
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
  };

  const inputBaseStyle = {
    width: "100%",
    padding: "0.75rem",
    border: `1px solid ${colors.border}`,
    borderRadius: "0.5rem",
    fontSize: "1rem",
    fontFamily: "inherit",
    transition: "border-color 0.15s ease",
    boxSizing: "border-box",
    background: colors.backgroundAlt,
    color: colors.text,
  };

  return (
    <>
      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }

        .registration-modal-container {
          width: 100%;
          max-width: 1000px;
          max-height: calc(100vh - 48px);
          overflow: auto;
          -webkit-overflow-scrolling: touch;
          border-radius: 14px;
          box-shadow: 0 20px 60px rgba(2,6,23,0.45);
          display: grid;
          grid-template-columns: 420px 1fr;
          gap: 1.25rem;
          padding: 1.15rem;
          background: ${colors.card};
          position: relative;
          animation: slideUp 0.22s ease-in-out;
        }

        .registration-modal-container::-webkit-scrollbar { width: 10px; height: 10px; }
        .registration-modal-container::-webkit-scrollbar-track { background: transparent; }
        .registration-modal-container::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.08); border-radius: 12px; border: 2px solid transparent; background-clip: padding-box; }
        .registration-modal-container { scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.08) transparent; }

        .registration-left-panel {
          padding: 1rem;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          gap: 0.9rem;
          justify-content: center;
          align-items: center; /* Center the image */
          min-height: 220px;
          background: ${colors.backgroundAlt}; /* Added a subtle background for the image container */
        }
        
        .registration-form-panel { padding: 0.15rem 0; min-height: 220px; }

        .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
        .form-group { margin-bottom: 1rem; }
        label.modal-label { display:block; margin-bottom:0.35rem; color: ${colors.text}; font-weight:600; font-size:0.95rem; }
        .modal-input:focus { outline:none; border-color: ${colors.primary}; box-shadow: 0 0 0 6px ${colors.primary}18; }

        .modal-submit-btn { width:100%; padding:0.95rem; background: linear-gradient(90deg, ${colors.primary}, ${colors.primary}); color:${colors.buttonText}; border:none; border-radius:0.6rem; font-weight:700; cursor:pointer; box-shadow: 0 8px 30px ${colors.primary}22; }
        .modal-submit-btn:disabled { opacity:0.75; cursor:not-allowed; }

        .radio-row { display:flex; gap:0.6rem; flex-wrap:wrap; align-items:center; }
        .radio-row label { display:flex; align-items:center; gap:0.45rem; color:${colors.text}; cursor:pointer; padding:0.18rem 0.2rem; border-radius:6px; }

        .interest-list { display:flex; flex-direction:column; gap:8px; margin-top:6px; }
        .interest-item { display:flex; align-items:center; gap:0.6rem; cursor:pointer; color: ${colors.text}; }
        .interest-item input { width: 18px; height: 18px; }

        @media (max-width: 920px) {
          .registration-modal-container { grid-template-columns: 1fr; padding: 0.9rem; gap: 0.9rem; max-width: 760px; }
          .form-grid { grid-template-columns: 1fr; }
          .registration-left-panel { order: -1; min-height: auto; }
        }
        @media (max-width: 480px) {
          .registration-modal-container { max-width:100%; width:100%; height:100%; border-radius:0; padding:0.6rem; max-height:100vh; }
          .registration-left-panel { padding:0.75rem; border-radius:8px; }
          .modal-close-btn { top:0.45rem; right:0.45rem; }
        }
      `}</style>

      <div style={overlay} onClick={onClose}>
        <div
          className="registration-modal-container"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
        >
          <button
            style={closeButtonStyle}
            onClick={onClose}
            className="modal-close-btn"
            aria-label="Close modal"
          >
            ×
          </button>

          <div className="registration-left-panel" aria-hidden={true}>
            <img
              src={Img}
              alt="Gurukul Entrance Test Advertisement"
              style={{
                width: "100%",
                maxHeight: "100%", // Ensures image does not overflow its container
                borderRadius: "8px",
                objectFit: "contain", // Changed from 'cover' to 'contain'
              }}
            />
          </div>

          <div className="registration-form-panel">
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                

                <div className="form-group">
                  <label className="modal-label" htmlFor="studentName">
                    Student Full Name{" "}
                    <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    id="studentName"
                    name="studentName"
                    type="text"
                    value={formData.studentName}
                    onChange={handleChange}
                    style={inputBaseStyle}
                    className="modal-input"
                    required
                    placeholder="Enter student's full name"
                  />
                </div>
              </div>

              <div className="form-grid" style={{ marginTop: 8 }}>
                <div className="form-group">
                  <label className="modal-label" htmlFor="schoolName">
                    School Name <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    id="schoolName"
                    name="schoolName"
                    type="text"
                    value={formData.schoolName}
                    onChange={handleChange}
                    style={inputBaseStyle}
                    className="modal-input"
                    required
                    placeholder="Enter school name"
                  />
                </div>

                <div className="form-group">
                  <label className="modal-label" htmlFor="villageOrCity">
                    Village or City <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    id="villageOrCity"
                    name="villageOrCity"
                    type="text"
                    value={formData.villageOrCity}
                    onChange={handleChange}
                    style={inputBaseStyle}
                    className="modal-input"
                    required
                    placeholder="Enter village or city"
                  />
                </div>
              </div>

              <div className="form-group" style={{ marginTop: 8 }}>
                <label className="modal-label" htmlFor="address">
                  Address <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  style={{
                    ...inputBaseStyle,
                    minHeight: "96px",
                    resize: "vertical",
                  }}
                  className="modal-input"
                  required
                  placeholder="Enter full address"
                />
              </div>

              <div className="form-grid" style={{ marginTop: 8 }}>
                <div className="form-group">
                  <label className="modal-label" htmlFor="mobileNumber">
                    Mobile Number <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    id="mobileNumber"
                    name="mobileNumber"
                    type="tel"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    style={inputBaseStyle}
                    className="modal-input"
                    required
                    placeholder="Enter mobile number"
                    pattern="[0-9]{10}"
                    maxLength="10"
                  />
                </div>

                <div className="form-group">
                  <label className="modal-label" htmlFor="emailId">
                    Email (optional)
                  </label>
                  <input
                    id="emailId"
                    name="emailId"
                    type="email"
                    value={formData.emailId}
                    onChange={handleChange}
                    style={inputBaseStyle}
                    className="modal-input"
                    placeholder="Enter email (optional)"
                  />
                </div>
              </div>

              <div className="form-grid" style={{ marginTop: 8 }}>
                <div className="form-group">
                  <label className="modal-label" htmlFor="lastExamPercentage">
                    Last Exam Percentage{" "}
                    <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    id="lastExamPercentage"
                    name="lastExamPercentage"
                    type="number"
                    inputMode="decimal"
                    min="0"
                    max="100"
                    step="0.01"
                    value={formData.lastExamPercentage}
                    onChange={handleChange}
                    style={inputBaseStyle}
                    className="modal-input"
                    required
                    placeholder="e.g., 85.5"
                  />
                </div>

                <div className="form-group">
                  <label className="modal-label">
                    Branch <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <div
                    className="radio-row"
                    role="radiogroup"
                    aria-label="Branch choice"
                  >
                    {/* Changed to 3 radio buttons: Commerce, Science, Other */}
                    <label>
                      <input
                        type="radio"
                        name="branchRadio"
                        value="Commerce"
                        checked={branchChoice === "Commerce"}
                        onChange={() => handleBranchChange("Commerce")}
                        required
                      />
                      <span>Commerce</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="branchRadio"
                        value="Science"
                        checked={branchChoice === "Science"}
                        onChange={() => handleBranchChange("Science")}
                        required
                      />
                      <span>Science</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="branchRadio"
                        value="Other"
                        checked={branchChoice === "Other"}
                        onChange={() => handleBranchChange("Other")}
                        required
                      />
                      <span>Other</span>
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <label className="modal-label">
                    Interested For <span style={{ color: "#ef4444" }}>*</span>
                  </label>

                  {getInterestedOptions().length > 0 ? (
                    <div
                      className="interest-list"
                      role="group"
                      aria-label="Interested for options"
                    >
                      {getInterestedOptions().map((opt) => (
                        <label key={opt} className="interest-item">
                          <input
                            type="checkbox"
                            name="interestedForCheckbox"
                            value={opt}
                            checked={(formData.interestedFor || []).includes(
                              opt
                            )}
                            onChange={() => handleInterestToggle(opt)}
                          />
                          <span>{opt}</span>
                        </label>
                      ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: colors.textSecondary,
                        fontSize: "0.95rem",
                      }}
                    >
                      {branchChoice
                        ? "No specific options for this branch."
                        : "Please select a Branch to see options."}
                    </div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: "0.75rem" }}>
                <button
                  type="submit"
                  className="modal-submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit Registration"}
                </button>
              </div>

              <div style={{ height: 18 }} aria-hidden="true" />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegistrationModal;